/* tslint:disable:object-literal-sort-keys */

export const messages = {
    "cz": {
      "countryCode": "cz",
      "alerts": {
        "workspace": {
          "unableToChangeWorkspace": "Nepodařilo se změnit pracovní prostor",
          "unableToLoadWorkspace": "Načtení pracovního prostoru se nezdařilo"
        },
        "permissions": {
          "camera": {
            "askForPermission": "Aplikace SKR-Audit potřebuje oprávnění pro přístup ke kameře. Toto oprávnění je nutné pro funkce skenování čárových a QR kódů. Bez tohoto oprávnění tyto funkce nebudou dostupné.",
            "permissionDeniedWarning": "Přístup ke kameře byl dříve aplikaci SKR-Audit odepřen. Funkce skenování čárových a QR kódů tedy nejsou dostupné. Chcete-li je používat, povolte přístup ke kameře ručně."
          }
        },
        "medias": {
          "failUpload": "Nahrávání média se nezdařilo.",
          "failGetIdFromFileName": "Médium bylo nahráno, ale aplikace Skin-Reporter ho nedokáže najít."
        }
      },
      archiveEditScreen: {
        saveAlert: {
          errorMessage: "MISSING TRANSLATION",
          successMessage: "MISSING TRANSLATION",
        },
      },
      archiveEditScreenHeader: {
        cote: "MISSING TRANSLATION",
        descriptionLevel: "MISSING TRANSLATION",
      },
      archiveSearchScreen: {
        createNewArchive: "MISSING TRANSLATION",
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Vaše přihlašovací údaje jsou nesprávné",
            "network": "Spojení se serverem se nezdařilo"
          },
          "form": {
            "password": {
              "error": "Zadejte své uživatelské jméno",
              "label": "Heslo"
            },
            "submit": "Přihlásit se",
            "submitting": "Připojování...",
            "username": {
              "error": "Zadejte své heslo",
              "label": "Uživatelské jméno"
            }
          }
        },
        "renew": {
          "slowNetwork": "Zdá se, že to trvá déle než obvykle, nevypínejte aplikaci.",
          "spinner": "Znovu vás připojujeme..."
        },
        "sso": {
          "errors": {
            "authenticationFailed": "Chyba: nelze dokončit ověření."
          },
          "selectIDP": "Přihlásit se pomocí...",
          "otherIDPs": "Jiné typy účtů"
        }
      },
      "actionBar": {
        "newItems": "Nové objekty",
        "auditCampaign": "Kampaně revize sbírek",
        "synchro": "Synchronizace"
      },
      "autoCompleteTextField": {
        "modal": {
          "okButton": "OK"
        }
      },
      "cameraScanner": {
        "scanCode": "Naskenovat čárový kód",
        "cancel": "Zrušit",
        "errors": {
          "cameraNotFound": "Nebyla zjištěna žádná kamera"
        }
      },
      createArchiveModal: {
        creationFailed: "MISSING TRANSLATION",
        descriptionLevel: "MISSING TRANSLATION",
        submitBtn: "MISSING TRANSLATION",
        submitting: "MISSING TRANSLATION",
        title: "MISSING TRANSLATION",
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Nasazeno dne",
          "checkForUpdate": {
            "help": "Pokud je dostupná aktualizace, nainstaluje se automaticky.",
            "title": "Zkontrolovat aktualizace"
          },
          "clearCache": {
            "help": "Pokud jste offline, ztratíte přístup ke všem datům uloženým v zařízení.",
            "title": "Vyprázdnit mezipaměť"
          },
          "overrideLocale": {
            "help": "Bude použita angličtina a nastavení vašeho zařízení bude ignorováno.",
            "title": "Vynutit anglický jazyk"
          },
          "resetLocaleOverride": {
            "help": "Použitý jazyk bude odpovídat nastavení vašeho zařízení",
            "title": "Obnovit výchozí jazyk"
          },
          "serviceWorker": {
            "help": "Panel s aktualizací se zobrazuje neustále? Klikněte zde!",
            "title": "Zavřít panel aktualizace"
          },
          "title": "Skin-REPORTER",
          "version": "verze"
        },
        "logout": "Opravdu se chcete odhlásit?"
      },
      "offlineRibbon": {
        "offline": "Jste offline",
        "online": "Jste připojeni"
      },
      "proxy": {
        "error": {
          "default": "Došlo k chybě u zdroje {uri}",
          "network": "Spojení se serverem se nezdařilo",
          "notFound": "Zdroj {uri} nebyl nalezen",
          "tokenHasExpired": "Vaše relace vypršela"
        }
      },
      "serviceWorker": {
        "updateAvailable": "Byla nainstalována aktualizace. Klikněte zde pro obnovení stránky nebo restartujte aplikaci.",
        "forceServiceWorkerUpdate": {
          "modalTitle": "Řešení problému",
          "versionCorrect": "Odpovídají níže uvedené informace verzi a datu sdělenému společností SKINsoft po poslední aktualizaci?",
          "yes": "Ano",
          "no": "Ne"
        }
      },
      "itemCard": {
        "detailsNotAvailable": "Podrobnosti nejsou k dispozici",
        "error": "Objekt nelze zobrazit",
        "identifier": "Inv. č. {identifier}",
        "identifierError": "Chyba identifikace",
        "location": "Lokace",
        "locationLabel": "Cíl: <strong>{title}</strong>",
        "unknownLocation": "Neznámá",
        "title": "Název",
        "locationSelector": {
          "title": "Vyberte lokaci",
          "validate": "Potvrdit"
        }
      },
      "entity": {
        "addItem": {
          "error": {
            "api": "Objekt se nepodařilo přidat",
            "network": "Spojení se serverem se nezdařilo"
          },
          "form": {
            "id": {
              "alreadyAdded": "Objekt již existuje v přesunu",
              "emptyError": "Naskenujte objekt nebo zadejte jeho inventární číslo",
              "label": "Inventární číslo",
              "notFoundError": "Objekt je neznámý"
            },
            "location": {
              "emptyError": "Vyberte lokaci",
              "label": "Cílová lokace",
              "notFoundError": "Lokace je neznámá"
            },
            "submit": "Přidat",
            "submitting": "Přidávání..."
          },
          "modal": {
            "title": "Přidat objekt"
          }
        },
        "closeMovement": {
          "form": {
            "location": {
              "inputPlaceholder": "Zadejte lokaci...",
              "noResult": "Žádný výsledek"
            }
          }
        }
      },
      "firewall": {
        "collabWarningMessage": "Váš účet nemá přiřazeného spolupracovníka, aplikace nemusí fungovat správně",
        "noGroupForUserWarningMessage": "Používání SKINreporteru vyžaduje, aby byl váš účet propojen se skupinou uživatelů"
      },
      genericEditScreen: {
        genericErrorMsg: "MISSING TRANSLATION",
        saveErrorMsg: "MISSING TRANSLATION",
        saveSuccessMsg: "MISSING TRANSLATION",
      },
      "maskFields": {
        "boolean": {
          "no": "Ne",
          "undefined": "Nedefinováno",
          "yes": "Ano"
        },
        "entitySelect": {
          "modalPlaceholder": "Klíčová slova nebo identifikátory..."
        }
      },
      "editItemScreen": {
        "author": "Autor",
        "inventoryNumber": "Inventární číslo",
        "confirmButton": "Potvrdit",
        "editButton": "Upravit",
        "saveNotification": {
          "errorMessage": "Při ukládání objektu došlo k chybě",
          "successMessage": "Objekt byl úspěšně uložen"
        },
        "sections": {
          "creation": "Vytvoření",
          "description": "Popis",
          "identification": "Identifikace",
          "location": "Lokace",
          "notes": "Poznámky",
          "state": "Stav"
        },
        "deleteNotification": {
          "errorMessage": "Při mazání ne­sync­hro­ni­zo­va­né­ho objektu došlo k chybě",
          "successMessage": "Objekt byl úspěšně odstraněn"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Při mazání ne­sync­hro­ni­zo­va­ných změn došlo k chybě",
          "successMessage": "Změny byly zrušeny"
        },
        "errorMessages": {
          "inventoryNumberNotUnique": "Toto inventární číslo je již přiřazeno"
        },
        "fieldDisabledOffline": "Tento údaj nelze zadat v offline režimu",
        "menu": {
          "saveModifications": "Uložit změny",
          "deleteNotSynchronizedNewItem": "Odstranit nový objekt",
          "deleteModificationsNotSynchronized": "Odstranit ne­sync­hro­ni­zo­va­né změny",
          "offlineWarning": "Změny jsou uloženy v zařízení, bude nutné je synchronizovat s databází po obnovení připojení.",
          "offlineShortWarning": "Upraveno v tomto zařízení",
          "addToCampaign": "Rekolovat tento objekt"
        }
      },
      "editRecordScreen": {
        "auditDate": "Datum revize sbírek",
        "fieldDisabledOffline": "Tento údaj nelze zadat v offline režimu",
        "foldAll": "Sbalit vše",
        "itemNotice": "Karta objektu",
        "linkedObject": "Související objekt",
        "realTimeLocation": "Lokace v reálném čase",
        "recordStatus": "Stav karty",
        "unfoldAll": "Rozbalit vše",
        "medias": {
          "accordionPanelTitle": "MÉDIA"
        },
        "menu": {
          "saveModifications": "Uložit změny",
          "changeRecordStatus": "Změnit stav karty",
          "statusModificationWarning": "Potvrdit změnu?",
          "offlineWarning": "Změny jsou uloženy v zařízení, bude nutné je synchronizovat s databází po obnovení připojení.",
          "offlineShortWarning": "Upraveno v tomto zařízení"
        },
        "notifications": {
          "saveError": "Při ukládání došlo k chybě",
          "saveSuccess": "Karta rekolace byla uložena",
          "stateTransitionError": "Při změně stavu karty došlo k chybě",
          "stateTransitionSuccess": "Stav karty byl úspěšně změněn"
        }
      },
      "defectTree": {
        "annotation": {
          "deleteConfirmationMessage": "Potvrdit smazání?",
          "defaultImageConfirmationMessage": "Nastavit jako výchozí obrázek?"
        }
      },
      "itemSearchScreen": {
        "camera": "FOTOAPARÁT",
        "modifyRecord": "UPRAVIT KARTU OBJEKTU",
        "createNewItem": "VYTVOŘIT NOVÝ OBJEKT"
      },
      "searchFeaturedCard": {
        "institutionLabel": "Instituce"
      },
      "selectItemErrorDialog": {
        "cancel": "Zrušit objekt",
        "cancelAll": "Zrušit všechny objekty",
        "description": "Výběr {0} objektů se nezdařil.",
        "retry": "Zkusit znovu pro tento objekt",
        "retryAll": "Zkusit znovu pro všechny objekty",
        "title": "Chyba při výběru obrázků"
      },
      "auditCampaignSearchScreen": {
        "inProgress": "Probíhá",
        "title": "Probíhající projekty revize sbírek/fyzické kontroly",
        "noResultsPlaceholder": "Momentálně nemáte oprávnění pracovat na žádné kampani"
      },
      "recordSearchScreen": {
        "auditors": "Revidující osoby",
        "campaignManager": "Vedoucí kampaně",
        "inventoryNumber": "Inventární číslo",
        "projectCreationDate": "Datum vytvoření projektu",
        "projectType": "Typ projektu",
        "realTimeLocation": "Lokace v reálném čase",
        "recordRefNumber": "Referenční karta",
        "status": "Stav",
        "title": "Karty revize sbírek",
        "unknowLocation": "Neznámá lokace",
        "menu": {
          "addItem": "Přidat objekt"
        }
      },
      "state": {
        "all": "Vše",
        "archived": "Archivováno",
        "canceled": "Zrušeno",
        "finalized": "Dokončeno",
        "inPreparation": "V přípravě",
        "inProgress": "Probíhá",
        "programmed": "Plánováno",
        "toValidated": "K potvrzení",
        "validated": "Potvrzeno",
        "aborted": "Přerušeno",
        "success": "Úspěšně dokončeno",
        "error": "Chyba",
        "none": "Žádná předchozí synchronizace"
      },
      "time": {
        "hours": "hodina(y)",
        "minutes": "minuta(y)",
        "seconds": "sekunda(y)"
      },
      "locationSelector": {
        "inputPlaceholder": "Zadejte lokaci",
        "title": "Vyberte lokalici",
        "validate": "Potvrdit"
      },
      "synchroModal": {
        "title": "Synchronizace",
        "lastFetch": "Poslední načtení",
        "duration": "Doba trvání",
        "status": "Stav",
        "details": "Podrobnosti",
        "lastSynchro": "Poslední synchronizace",
        "noEntityToSync": "Žádné entity k synchronizaci",
        "connectionWarningPrefix": "Pro odesílání nebo načítání dat musíte být připojeni k internetu",
        "connectWarningSend": "odeslat",
        "connectWarningRetrieve": "načíst",
        "connectionWarningSuffix": "data",
        "noDataToSync": "Momentálně nejsou žádná data k synchronizaci",
        "localIconInfoPrefix": "Ikona",
        "localIconInfoSuffix": "označuje, že odpovídající data byla lokálně upravena a bude nutné je synchronizovat se vzdálenou databází.",
        "retrieveAll": "Načíst vše",
        "finishedSynchros": "Synchronizace dokončeny",
        "syncAll": "Synchronizovat vše",
        "remainsToSynchronize": "Zbývá synchronizovat",
        "cleanImageCache": "Vyčistit média v mezipaměti",
        "cachedImagedCleaned": "„Duchovité“ soubory byly odstraněny!",
        "cleanCacheDown": "Vyprázdnit mezipaměť",
        "cacheDownCleaned": "Mezipaměť byla vyprázdněna",
        "cleanCacheUp": "Odstranit všechny ne­sync­hro­ni­zo­va­né změny",
        "cacheUpCleaned": "Všechny ne­sync­hro­ni­zo­va­né změny byly odstraněny!"
      },
      "entityNames": {
        "items": "Položky",
        archives: "MISSING TRANSLATION",
        "auditRecords": "Záznamy revize sbírek",
        "audits": "Kampaně revize sbírek",
        "thesaurusTerms": "Pojmy tezauru",
        "thesaurus": "Tezaurus",
        "entityFields": "Systémová data",
        "collaborators": "Spolupracovníci",
        "authorities": "Autority",
        "aliases": "Aliasy",
        "locations": "Lokace",
        "works": "Díla",
        "expressions": "Vyjádření",
        "manifestations": "Manifestace",
        "specimens": "MISSING TRANSLATION"
      },
      "search": {
        "options": {
          "sortType": {
            "auditType": "Typ projektu",
            "campaignCreationDate": "Datum vytvoření kampaně",
            "creationDate": "Datum vytvoření",
            "identificationNumber": "Identifikační číslo",
            "identifier": "Hlavní identifikátor",
            "lastModification": "Poslední úprava",
            "mainTitle": "Hlavní název",
            "referenceNumber": "Referenční číslo"
          }
        },
        "queryPlaceholder": "Klíčová slova nebo číslo kampaně",
        "totalCount": "{totalResults} Výsledek(y): 1 -",
        "noResults": "Žádný výsledek",
        "title": "Muzejní objekty"
      },
      "itemCreationImagePopup": {
        "title": "Přidat obrázek",
        "addImage": "PŘIDAT OBRÁZEK",
        "ignore": "POZDĚJI, PŘESKOČIT TENTO KROK"
      },
      "uploadImageFailureDialog": {
        "cancel": "Zrušit obrázek {0}",
        "cancelAll": "Zrušit všechny obrázky",
        "description": "Nahrávání {0} obrázků se nezdařilo.",
        "imageAndNumber": "Obrázek {0}",
        "retry": "Zkusit znovu pro obrázek {0}",
        "retryAll": "Zkusit znovu pro všechny obrázky",
        "title": "Nahrávání obrázků se nezdařilo"
      },
      "SpecimenSearchScreen": {
        "createNewSpecimen": "MISSING TRANSLATION"
      },
    },
    "en": {
        "countryCode": "gb",
        "alerts": {
          "workspace": {
            "unableToChangeWorkspace": "Failed to change workspace",
            "unableToLoadWorkspace": "Failed to load workspace",
          },
          "permissions": {
            "camera": {
              askForPermission: "SKR-Audit needs permission to access the camera. This permission is necessary for the barcode/QR-code scanning functionalities. Without this permission these functions cannot be provided.",
              permissionDeniedWarning: "Permission to access the camera has previously been denied to SKR-Audit. Barcode/QR-code scanning functionalities are therefore not available. To be able to access them, please manually authorise access to the camera for SKR-Audit.",
            }
          },
          "medias": {
            "failUpload": "Failed to upload the media.",
            "failGetIdFromFileName": "The media has been uploaded, but Skin-Reporter cannot find it.",
          },
        },
        archiveEditScreen: {
          saveAlert: {
            errorMessage: "MISSING TRANSLATION",
            successMessage: "MISSING TRANSLATION",
          },
        },
        archiveEditScreenHeader: {
          cote: "MISSING TRANSLATION",
          descriptionLevel: "MISSING TRANSLATION",
        },
        archiveSearchScreen: {
          createNewArchive: "MISSING TRANSLATION",
        },
        "auth": {
          "login": {
            "error": {
              "credentials": "Username and/or password incorrect",
              "network": "Communication with server has failed"
            },
            "form": {
              "password": {
                "error": "Please enter your username",
                "label": "Password"
              },
              "submit": "Log in",
              "submitting": "Logging in",
              "username": {
                "error": "Please enter your password",
                "label": "Username"
              }
            }
          },
          "renew": {
            "slowNetwork": "This is taking more time than usual. Please do not quit the application.",
            "spinner": "Getting you back online"
          },
          sso: {
            errors: {
              authenticationFailed: "Error: unable to complete authentication."
            },
            selectIDP: "Log in with...",
            otherIDPs: "Other account types",
          }
        },
        "actionBar": {
          "newItems": "New Items",
          "auditCampaign": "Audit Campaigns",
          "synchro": "Synchro"
        },
        autoCompleteTextField: {
          modal: {
            okButton: "Ok",
          },
        },
        "cameraScanner": {
          "scanCode": "Scan the barcode",
          "cancel": "Cancel",
          errors: {
            cameraNotFound: "No camera detected",
          },
        },
        createArchiveModal: {
          creationFailed: "MISSING TRANSLATION",
          descriptionLevel: "MISSING TRANSLATION",
          submitBtn: "MISSING TRANSLATION",
          submitting: "MISSING TRANSLATION",
          title: "MISSING TRANSLATION",
        },
        "navbar": {
          "contextMenuModal": {
            "buildDate": "Deployment",
            "checkForUpdate": {
              "help": "If an update is available, it will be installed automatically.",
              "title": "Please check for updates"
            },
            "clearCache": {
              "help": "If you are offline, this process will remove access to all data stored on your device",
              "title": "Clear cache memory"
            },
            "overrideLocale": {
              "help": "The english langage will be used and your device’s settings will be ignored",
              "title": "Force english langage"
            },
            "resetLocaleOverride": {
              "help": "The langage will depend on your device’s settings",
              "title": "Reset the language"
            },
            "serviceWorker": {
              help: "The update banner keeps appearing? Click here!",
              title: "Close the update banner",
            },
            "title": "Skin-REPORTER",
            "version": "version",
          },
          "logout": "Are you sure that you want to log out?"
        },
        "offlineRibbon": {
          "offline": "You are now offline",
          "online": "You are now online"
        },
        "proxy": {
          "error": {
            "default": "An error occured on the resource {uri}",
            "network": "Communication with the server has failed",
            "notFound": "The resource {uri} could not be found",
            "tokenHasExpired": "Your session has expired"
          }
        },
        "serviceWorker": {
          "updateAvailable": "An update has been installed. You can either click here to refresh the page or restart the application.",
          forceServiceWorkerUpdate: {
            modalTitle: "Resolution of the problem",
            versionCorrect: "Do the information below correspond to the version and date provided by SKINsoft after the last update ?",
            yes: "Yes",
            no: "No",
          },
        },
        "itemCard": {
          "detailsNotAvailable": "Details not available",
          "error": "The item cannot be displayed",
          "identifier": "N° Inv. {identifier}",
          "identifierError": "Identifier error",
          "location": "Location",
          "locationLabel": "Destination: <strong>{title}</strong>",
          "unknownLocation": "Unkonwn",
          "title": "Title",
          "locationSelector": {
            "title": "Select a location",
            "validate": "Validate"
          }
        },
        "entity": {
          "addItem": {
            "error": {
              "api": "The object could not be added",
              "network": "The communication with the server has failed"
            },
            "form": {
              "id": {
                "alreadyAdded": "The object already exists in this selection",
                "emptyError": "Please scan an item barcode or type its inventory number",
                "label": "Inventory number",
                "notFoundError": "The item is unknown"
              },
              "location": {
                "emptyError": "Select a location",
                "label": "Arrival location",
                "notFoundError": "Unknown location"
              },
              "submit": "Add",
              "submitting": "Adding..."
            },
            "modal": {
              "title": "Add an item"
            }
          },
          "closeMovement": {
            "form": {
              "location": {
                "inputPlaceholder": "Select a location...",
                "noResult": "There is no result"
              }
            }
          }
        },
        "firewall": {
          "collabWarningMessage": "Your account doesn't any associated collaborator, the app may be disfunctionning",
          "noGroupForUserWarningMessage": "You user account needs to be part of group of users to be able to user SKINreporter"
        },
        genericEditScreen: {
          genericErrorMsg: "MISSING TRANSLATION",
          saveErrorMsg: "MISSING TRANSLATION",
          saveSuccessMsg: "MISSING TRANSLATION",
        },
        "maskFields": {
          "boolean": {
            "no": "No",
            "undefined": "Undefined",
            "yes": "Yes"
          },
          "entitySelect": {
            "modalPlaceholder": "Keywords or identifiers..."
          }
        },
        "editItemScreen": {
          "author": "Author",
          "inventoryNumber": "Inventory Number",
          "confirmButton": "Save",
          "editButton": "Edit",
          "saveNotification": {
            "errorMessage": "En error occured while saving the item",
            "successMessage": "Item successfully saved"
          },
          sections: {
            creation: "Creation",
            description: "Description",
            identification: "Identification",
            location: "Location",
            notes: "Notes",
            state: "Object condition",
          },
          "deleteNotification": {
            "errorMessage": "An error occurred while deleting the unsynchronised object",
            "successMessage": "The object has been successfully deleted"
          },
          "deleteModificationsNotification": {
            "errorMessage": " An error has occurred while deleting unsynchronised changes",
            "successMessage": "The changes have been cancelled"
          },
          "errorMessages": {
            "inventoryNumberNotUnique": "This inventory number is already attributed"
          },
          fieldDisabledOffline: "This field is not available in offline mode",
          "menu": {
            "saveModifications": "Save modifications",
            "deleteNotSynchronizedNewItem": "Delete the new object",
            "deleteModificationsNotSynchronized": "Delete unsynchronized modifications",
            "offlineWarning": "Modifications are saved on this device, you will have to synchronize them with the database when the network is back.",
            "offlineShortWarning": "Modified on this device",
            "addToCampaign": "Audit this item"
          }
        },
        "editRecordScreen": {
          "auditDate": "Audit date",
          fieldDisabledOffline: "This field is not available in offline mode",
          "foldAll": "Fold all",
          "itemNotice": "Go to item",
          "linkedObject": "Linked item",
          "realTimeLocation": "Realtime location",
          "recordStatus": "Record status",
          "unfoldAll": "Unfold all",
          "medias": {
            "accordionPanelTitle": "ATTACHED MULTIMEDIA"
          },
          "menu": {
            "saveModifications": "Save modifications",
            "changeRecordStatus": "Change record status",
            "statusModificationWarning": "Confirm modification ?",
            "offlineWarning": "Modifications are saved on this device, you will have to synchronize them with the database when the network is back.",
            "offlineShortWarning": "Modified on this device"
          },
          "notifications": {
            "saveError": "An error occurred while saving",
            "saveSuccess": "Record saved",
            "stateTransitionError": "An error occurred while modifying the record",
            "stateTransitionSuccess": "record status successfully updated"
          }
        },
        "defectTree": {
          "annotation": {
            "deleteConfirmationMessage": "Confirm deletion ?",
            "defaultImageConfirmationMessage": "Set as default image ?"
          }
        },
        "itemSearchScreen": {
          "camera": "CAMERA",
          "modifyRecord": "MODIFY ITEM RECORD",
          "createNewItem": "CREATE NEW ITEM"
        },
        "searchFeaturedCard": {
          "institutionLabel": "Institution"
        },
        selectItemErrorDialog: {
          cancel: "Abandon object",
          cancelAll: "Abandon all objects",
          description: "The selection of {0} objects has failed.",
          retry: "Retry for this object",
          retryAll: "Retry for all objects",
          title: "Failed to select images",
        },
        "auditCampaignSearchScreen": {
          "inProgress": "In progress",
          "title": "Audit Campaigns in progress",
          "noResultsPlaceholder": "You are not authorized to work on any campaign at this time"
        },
        "recordSearchScreen": {
          "auditors": "Auditors",
          "campaignManager": "Campaign manager",
          "inventoryNumber": "Inventory number",
          "projectCreationDate": "Project creation date",
          "projectType": "Project type",
          "realTimeLocation": "Realtime location",
          "recordRefNumber": "Record reference number",
          "status": "Status",
          "title": "Audit records",
          "unknowLocation": "Unknown location",
          "menu": {
            "addItem": "Add item"
          }
        },
        "state": {
          "all": "All",
          "archived": "Archived",
          "canceled": "Canceled",
          "finalized": "Finalized",
          "inPreparation": "In preparation",
          "inProgress": "In progress",
          "programmed": "Programmed",
          "toValidated": "Needs validation",
          "validated": "Validated",
          "aborted": "Aborted",
          "success": "Successfully finished",
          "error": "Error",
          "none": "No previous synchronization"
        },
        "time": {
          "hours": "hour(s)",
          "minutes": "minute(s)",
          "seconds": "second(s)"
        },
        "locationSelector": {
          "inputPlaceholder": "Type a location",
          "title": "Select a location",
          "validate": "Validate"
        },
        "synchroModal": {
          "title": "Synchronization",
          "lastFetch": "Last fetching",
          "duration": "Duration",
          "status": "Status",
          "details": "Details",
          "lastSynchro": "Last synchronization",
          "noEntityToSync": "No entity to synchronize",
          "connectionWarningPrefix": "You must have an internet connection to be able to",
          "connectWarningSend": "send",
          "connectWarningRetrieve": "retrive",
          "connectionWarningSuffix": "data",
          "noDataToSync": "No data to synchronize for now",
          "localIconInfoPrefix": "The icon",
          "localIconInfoSuffix": " indicates that the corresponding data has been modified localy and will need to be synchronized with the remote database.",
          "retrieveAll": "Retrieve All",
          "finishedSynchros": "Finished synchronizations",
          "syncAll": "Sychronize all",
          "remainsToSynchronize": "Remains to synchronize",
          "cleanImageCache": "Clean media in cache",
          "cachedImagedCleaned": "Gohst media have been cleaned !",
          "cleanCacheDown": "Clear the cache",
          "cacheDownCleaned": "The cache has been cleared",
          "cleanCacheUp": "Delete every unsynchronized modifications",
          "cacheUpCleaned": "All unsynchronized modifications have been deleted !"
        },
        "entityNames": {
          "items": "Items",
          archives: "MISSING TRANSLATION",
          "auditRecords": "Audit records",
          "audits": "Audit campaings",
          "thesaurusTerms": "Thesaurus terms",
          "thesaurus": "Thesaurus",
          "entityFields": "System data",
          "collaborators": "Collaborators",
          "authorities": "Authorities",
          "aliases": "Aliases",
          "locations": "Locations",
          "works": "Works",
          "expressions": "Expressions",
          "manifestations": "Manifestations",
          "specimens": "Specimens"
        },
        "search": {
          "options": {
            "sortType": {
              "auditType": "Type of project",
              "campaignCreationDate": "Campaign creation date",
              "identificationNumber": "Identification number",
              "creationDate": "Date of Creation",
              "identifier": "Main identifier",
              "lastModification": "Last Modification",
              "mainTitle": "Main Title",
              "referenceNumber": "Reference number"
            }
          },
          "queryPlaceholder": "Keywords or campaign number",
          "totalCount": "{totalResults} Result(s) : 1 -",
          "noResults": "No results",
          "title": "Museum objects"
        },
        "itemCreationImagePopup": {
          "title": "Add an image",
          "addImage": "ADD AN IMAGE",
          "ignore": "LATER, IGNORE THIS STAGE"
        },
        uploadImageFailureDialog: {
          cancel: "Abandon image {0}",
          cancelAll: "Abandon all images",
          description: "The upload of {0} images has failed.",
          imageAndNumber: "Image {0}",
          retry: "Retry for image {0}",
          retryAll: "Retry for all images",
          title: "Image upload failure",
        },
        "SpecimenSearchScreen": {
          "createNewSpecimen": "CREATE NEW SPECIMEN"
        }
    },
    "en-DIOR": {
      
    },
    "en-us": {
        "countryCode": "us",
        "alerts": {
          "workspace": {
            "unableToChangeWorkspace": "Failed to change workspace",
            "unableToLoadWorkspace": "Failed to load workspace",
          },
          "permissions": {
            "camera": {
              askForPermission: "SKR-Audit needs permission to access the camera. This permission is necessary for the barcode/QR-code scanning functionalities. Without this permission these functions cannot be provided.",
              permissionDeniedWarning: "Permission to access the camera has previously been denied to SKR-Audit. Barcode/QR-code scanning functionalities are therefore not available. To be able to access them, please manually authorise access to the camera for SKR-Audit.",
            }
          },
          "medias": {
            "failUpload": "Failed to upload the media.",
            "failGetIdFromFileName": "The media has been uploaded, but Skin-Reporter cannot find it.",
          },
        },
        "auth": {
          "login": {
            "error": {
              "credentials": "Username and/or password incorrect",
              "network": "Communication with server has failed"
            },
            "form": {
              "password": {
                "error": "Please enter your username",
                "label": "Password"
              },
              "submit": "Log in",
              "submitting": "Logging in",
              "username": {
                "error": "Please enter your password",
                "label": "Username"
              }
            }
          },
          "renew": {
            "slowNetwork": "This is taking more time than usual. Please do not quit the application.",
            "spinner": "Getting you back online"
          },
          sso: {
            errors: {
              authenticationFailed: "Error: unable to complete authentication."
            },
            selectIDP: "Log in with...",
            otherIDPs: "Other account types",
          }
        },
        "actionBar": {
          "newItems": "New Items",
          "auditCampaign": "Audit Campaigns",
          "synchro": "Synchro"
        },
        autoCompleteTextField: {
          modal: {
            okButton: "Ok",
          },
        },
        "cameraScanner": {
          "scanCode": "Scan the barcode",
          "cancel": "Cancel",
          errors: {
            cameraNotFound: "No camera detected",
          },
        },
        "navbar": {
          "contextMenuModal": {
            "buildDate": "Deployment",
            "checkForUpdate": {
              "help": "If an update is available, it will be installed automatically.",
              "title": "Please check for updates"
            },
            "clearCache": {
              "help": "If you are offline, this process will remove access to all data stored on your device",
              "title": "Clear cache memory"
            },
            "overrideLocale": {
              "help": "The english langage will be used and your device’s settings will be ignored",
              "title": "Force english langage"
            },
            "resetLocaleOverride": {
              "help": "The langage will depend on your device’s settings",
              "title": "Reset the language"
            },
            "serviceWorker": {
              help: "The update banner keeps appearing? Click here!",
              title: "Close the update banner",
            },
            "title": "Skin-REPORTER",
            "version": "version",
          },
          "logout": "Are you sure that you want to log out?"
        },
        "offlineRibbon": {
          "offline": "You are now offline",
          "online": "You are now online"
        },
        "proxy": {
          "error": {
            "default": "An error occured on the resource {uri}",
            "network": "Communication with the server has failed",
            "notFound": "The resource {uri} could not be found",
            "tokenHasExpired": "Your session has expired"
          }
        },
        "serviceWorker": {
          "updateAvailable": "An update has been installed. You can either click here to refresh the page or restart the application.",
          forceServiceWorkerUpdate: {
            modalTitle: "Resolution of the problem",
            versionCorrect: "Do the information below correspond to the version and date provided by SKINsoft after the last update ?",
            yes: "Yes",
            no: "No",
          },
        },
        "itemCard": {
          "detailsNotAvailable": "Details not available",
          "error": "The item cannot be displayed",
          "identifier": "N° Inv. {identifier}",
          "identifierError": "Identifier error",
          "location": "Location",
          "locationLabel": "Destination: <strong>{title}</strong>",
          "unknownLocation": "Unkonwn",
          "title": "Title",
          "locationSelector": {
            "title": "Select a location",
            "validate": "Validate"
          }
        },
        "entity": {
          "addItem": {
            "error": {
              "api": "The object could not be added",
              "network": "The communication with the server has failed"
            },
            "form": {
              "id": {
                "alreadyAdded": "The object already exists in this selection",
                "emptyError": "Please scan an item barcode or type its inventory number",
                "label": "Inventory number",
                "notFoundError": "The item is unknown"
              },
              "location": {
                "emptyError": "Select a location",
                "label": "Arrival location",
                "notFoundError": "Unknown location"
              },
              "submit": "Add",
              "submitting": "Adding..."
            },
            "modal": {
              "title": "Add an item"
            }
          },
          "closeMovement": {
            "form": {
              "location": {
                "inputPlaceholder": "Select a location...",
                "noResult": "There is no result"
              }
            }
          }
        },
        "firewall": {
          "collabWarningMessage": "Your account doesn't any associated collaborator, the app may be disfunctionning",
          "noGroupForUserWarningMessage": "You user account needs to be part of group of users to be able to user SKINreporter"
        },
        "maskFields": {
          "boolean": {
            "no": "No",
            "undefined": "Undefined",
            "yes": "Yes"
          },
          "entitySelect": {
            "modalPlaceholder": "Keywords or identifiers..."
          }
        },
        "editItemScreen": {
          "author": "Author",
          "inventoryNumber": "Inventory Number",
          "confirmButton": "Save",
          "editButton": "Edit",
          "saveNotification": {
            "errorMessage": "En error occured while saving the item",
            "successMessage": "Item successfully saved"
          },
          sections: {
            creation: "Creation",
            description: "Description",
            identification: "Identification",
            location: "Location",
            notes: "Notes",
            state: "Object condition",
          },
          "deleteNotification": {
            "errorMessage": "An error occurred while deleting the unsynchronised object",
            "successMessage": "The object has been successfully deleted"
          },
          "deleteModificationsNotification": {
            "errorMessage": " An error has occurred while deleting unsynchronised changes",
            "successMessage": "The changes have been cancelled"
          },
          "errorMessages": {
            "inventoryNumberNotUnique": "This inventory number is already attributed"
          },
          fieldDisabledOffline: "This field is not available in offline mode",
          "menu": {
            "saveModifications": "Save modifications",
            "deleteNotSynchronizedNewItem": "Delete the new object",
            "deleteModificationsNotSynchronized": "Delete unsynchronized modifications",
            "offlineWarning": "Modifications are saved on this device, you will have to synchronize them with the database when the network is back.",
            "offlineShortWarning": "Modified on this device",
            "addToCampaign": "Audit this item"
          }
        },
        "editRecordScreen": {
          "auditDate": "Audit date",
          fieldDisabledOffline: "This field is not available in offline mode",
          "itemNotice": "Go to item",
          "foldAll": "Fold all",
          "linkedObject": "Linked item",
          "realTimeLocation": "Realtime location",
          "recordStatus": "Record status",
          "unfoldAll": "Unfold all",
          "medias": {
            "accordionPanelTitle": "ATTACHED MULTIMEDIA"
          },
          "menu": {
            "saveModifications": "Save modifications",
            "changeRecordStatus": "Change record status",
            "statusModificationWarning": "Confirm modification ?",
            "offlineWarning": "Modifications are saved on this device, you will have to synchronize them with the database when the network is back.",
            "offlineShortWarning": "Modified on this device"
          },
          "notifications": {
            "saveError": "An error occurred while saving",
            "saveSuccess": "Record saved",
            "stateTransitionError": "An error occurred while modifying the record",
            "stateTransitionSuccess": "record status successfully updated"
          }
        },
        "defectTree": {
          "annotation": {
            "deleteConfirmationMessage": "Confirm deletion ?",
            "defaultImageConfirmationMessage": "Set as default image ?"
          }
        },
        "itemSearchScreen": {
          "camera": "CAMERA",
          "modifyRecord": "MODIFY ITEM RECORD",
          "createNewItem": "CREATE NEW ITEM"
        },
        "searchFeaturedCard": {
          "institutionLabel": "Institution"
        },
        selectItemErrorDialog: {
          cancel: "Abandon object",
          cancelAll: "Abandon all objects",
          description: "The selection of {0} objects has failed.",
          retry: "Retry for this object",
          retryAll: "Retry for all objects",
          title: "Failed to select images",
        },
        "auditCampaignSearchScreen": {
          "inProgress": "In progress",
          "title": "Audit Campaigns in progress",
          "noResultsPlaceholder": "You are not authorized to work on any campaign at this time"
        },
        "recordSearchScreen": {
          "auditors": "Auditors",
          "campaignManager": "Campaign manager",
          "inventoryNumber": "Inventory number",
          "projectCreationDate": "Project creation date",
          "projectType": "Project type",
          "realTimeLocation": "Realtime location",
          "recordRefNumber": "Record reference number",
          "status": "Status",
          "title": "Audit records",
          "unknowLocation": "Unknown location",
          "menu": {
            "addItem": "Add item"
          }
        },
        "state": {
          "all": "All",
          "archived": "Archived",
          "canceled": "Canceled",
          "finalized": "Finalized",
          "inPreparation": "In preparation",
          "inProgress": "In progress",
          "programmed": "Programmed",
          "toValidated": "Needs validation",
          "validated": "Validated",
          "aborted": "Aborted",
          "success": "Successfully finished",
          "error": "Error",
          "none": "No previous synchronization"
        },
        "time": {
          "hours": "hour(s)",
          "minutes": "minute(s)",
          "seconds": "second(s)"
        },
        "locationSelector": {
          "inputPlaceholder": "Type a location",
          "title": "Select a location",
          "validate": "Validate"
        },
        "synchroModal": {
          "title": "Synchronization",
          "lastFetch": "Last fetching",
          "duration": "Duration",
          "status": "Status",
          "details": "Details",
          "lastSynchro": "Last synchronization",
          "noEntityToSync": "No entity to synchronize",
          "connectionWarningPrefix": "You must have an internet connection to be able to",
          "connectWarningSend": "send",
          "connectWarningRetrieve": "retrive",
          "connectionWarningSuffix": "data",
          "noDataToSync": "No data to synchronize for now",
          "localIconInfoPrefix": "The icon",
          "localIconInfoSuffix": " indicates that the corresponding data has been modified localy and will need to be synchronized with the remote database.",
          "retrieveAll": "Retrieve All",
          "finishedSynchros": "Finished synchronizations",
          "syncAll": "Sychronize all",
          "remainsToSynchronize": "Remains to synchronize",
          "cleanImageCache": "Clean media in cache",
          "cachedImagedCleaned": "Gohst media have been cleaned !",
          "cleanCacheDown": "Clear the cache",
          "cacheDownCleaned": "The cache has been cleared",
          "cleanCacheUp": "Delete every unsynchronized modifications",
          "cacheUpCleaned": "All unsynchronized modifications have been deleted !"
        },
        "entityNames": {
          "items": "Items",
          "auditRecords": "Audit records",
          "audits": "Audit campaings",
          "thesaurusTerms": "Thesaurus terms",
          "thesaurus": "Thesaurus",
          "entityFields": "System data",
          "collaborators": "Collaborators",
          "authorities": "Authorities",
          "aliases": "Aliases",
          "locations": "Locations",
          "works": "Works",
          "expressions": "Expressions",
          "manifestations": "Manifestations",
          "specimens": "Specimens"
        },
        "search": {
          "options": {
            "sortType": {
              "auditType": "Type of project",
              "campaignCreationDate": "Campaign creation date",
              "identificationNumber": "Identification number",
              "creationDate": "Date of Creation",
              "identifier": "Main identifier",
              "lastModification": "Last Modification",
              "mainTitle": "Main Title",
              "referenceNumber": "Reference number"
            }
          },
          "queryPlaceholder": "Keywords or campaign number",
          "totalCount": "{totalResults} Result(s) : 1 -",
          "noResults": "No results",
          "title": "Museum objects"
        },
        "itemCreationImagePopup": {
          "title": "Add an image",
          "addImage": "ADD AN IMAGE",
          "ignore": "LATER, IGNORE THIS STAGE"
        },
        uploadImageFailureDialog: {
          cancel: "Abandon image {0}",
          cancelAll: "Abandon all images",
          description: "The upload of {0} images has failed.",
          imageAndNumber: "Image {0}",
          retry: "Retry for image {0}",
          retryAll: "Retry for all images",
          title: "Image upload failure",
        },
        "SpecimenSearchScreen": {
          "createNewSpecimen": "CREATE NEW SPECIMEN"
        }
    },
    "fr": {
        "countryCode": "fr",
        "alerts": {
          "workspace": {
            "unableToChangeWorkspace": "Échec du changement d'espace de travail",
            "unableToLoadWorkspace": "Le chargement de l'espace de travail a échoué",
          },
          "permissions": {
            "camera": {
              askForPermission: "SKR-Audit a besoin de la permission d'accéder à la caméra. Cette permission est nécessaire pour les fonctionnalités de scan de code-barre/QR-code. Sans cette permission ces fonctionnalités ne pourront être assurées.",
              permissionDeniedWarning: "La permission d'accéder à la caméra a été refusée à SKR-Audit auparavant. Les fonctionnalités de scan de code-barre/QR-code ne sont donc pas disponible. Pour pouvoir y accéder, merci d'autoriser manuellement l'accès à la caméra pour SKR-Audit.",
            }
          },
          "medias": {
            "failUpload": "Échec du téléversement du média.",
            "failGetIdFromFileName": "Le média a été téléversé, mais Skin-Reporter ne parvient pas à le trouver.",
          },
        },
        archiveEditScreen: {
          saveAlert: {
            errorMessage: "Une erreur est survenue pendant la sauvegarde de l'archive",
            successMessage: "L'archive a été sauvegardée avec succès",
          },
        },
        archiveEditScreenHeader: {
          cote: "MISSING TRANSLATION",
          descriptionLevel: "Niveau de description :",
        },
        archiveSearchScreen: {
          createNewArchive: "CRÉER UNE NOUVELLE ARCHIVE",
        },
        "auth": {
          "login": {
            "error": {
              "credentials": "Vos identifiants sont incorrects",
              "network": "La communication avec le serveur a échoué"
            },
            "form": {
              "password": {
                "error": "Veuillez saisir votre nom d'utilisateur",
                "label": "Mot de passe"
              },
              "submit": "Se connecter",
              "submitting": "Connexion...",
              "username": {
                "error": "Veuillez saisir votre mot de passe",
                "label": "Nom d'utilisateur"
              }
            }
          },
          "renew": {
            "slowNetwork": "Cela semble mettre plus de temps que d'habitude, ne quittez pas l'application.",
            "spinner": "Nous vous reconnectons..."
          },
          sso: {
            errors: {
              authenticationFailed: "Erreur : impossible de finaliser l'authentification."
            },
            selectIDP: "S'authentifier avec...",
            otherIDPs: "Autres types de comptes",
          },
        },
        "actionBar": {
          "newItems": "Nouveaux objets",
          "auditCampaign": "Campagnes de récolement",
          "synchro": "Synchro"
        },
        autoCompleteTextField: {
          modal: {
            okButton: "Ok",
          },
        },
        "cameraScanner": {
          "scanCode": "Scanner un code-barre",
          "cancel": "Annuler",
          errors: {
            cameraNotFound: "Aucune caméra n'a été détectée",
          },
        },
        createArchiveModal: {
          creationFailed: "La création de l'archive a échouée",
          descriptionLevel: "Niveau de description",
          submitBtn: "Créer",
          submitting: "Création...",
          title: "Création d'une unité d'archives",
        },
        "navbar": {
          "contextMenuModal": {
            "buildDate": "Déployé le",
            "checkForUpdate": {
              "help": "Si une mise à jour est disponible, elle s'installera automatiquement.",
              "title": "Vérifiez les mises à jour"
            },
            "clearCache": {
              "help": "Si vous êtes hors-ligne, cela supprime l'accès à toutes les données stockées sur l'appareil.",
              "title": "Vider le cache"
            },
            "overrideLocale": {
              "help": "La langue anglaise sera utilisée et le paramétrage de votre terminal ignoré.",
              "title": "Forcer la langue anglaise"
            },
            "resetLocaleOverride": {
              "help": "La langue utilisé dépendra du paramètrage de votre terminal",
              "title": "Réinitialiser la langue"
            },
            "serviceWorker": {
              help: "Le bandeau de mise à jour s'affiche continuellement ? Cliquez ici !",
              title: "Fermer le bandeau de mise à jour",
            },
            "title": "Skin-REPORTER",
            "version": "version",
          },
          "logout": "Etes-vous sûr de vouloir vous déconnecter ?"
        },
        "offlineRibbon": {
          "offline": "Vous êtes hors connexion",
          "online": "Vous êtes connecté"
        },
        "proxy": {
          "error": {
            "default": "Une erreur s'est produite sur la ressource {uri}",
            "network": "La communication avec le serveur a échoué",
            "notFound": "La ressource {uri} n'a pas été trouvée",
            "tokenHasExpired": "Votre session a expiré"
          }
        },
        "serviceWorker": {
          "updateAvailable": "Une mise à jour a été installée. Cliquez ici pour recharger la page ou relancez l'application",
          forceServiceWorkerUpdate: {
            modalTitle: "Résolution du problème",
            versionCorrect: "Les informations ci-dessous correspondent-elles à la version et la date transmises par SKINsoft après la dernière mise à jour ?",
            yes: "Oui",
            no: "Non",
          },
        },
        "itemCard": {
          "detailsNotAvailable": "Détails non disponible",
          "error": "L'objet ne peut pas être affiché",
          "identifier": "N° Inv. {identifier}",
          "identifierError": "Erreur d'identification",
          "location": "Localisation",
          "locationLabel": "Destination: <strong>{title}</strong>",
          "unknownLocation": "Inconnue",
          "title": "Titre",
          "locationSelector": {
            "title": "Choisissez une localisation",
            "validate": "Valider"
          }
        },
        "entity": {
          "addItem": {
            "error": {
              "api": "L'objet n'a pas pu être ajouté",
              "network": "La communication avec le serveur a échoué"
            },
            "form": {
              "id": {
                "alreadyAdded": "L'objet est déjà existant dans le mouvement",
                "emptyError": "Veuillez scanner un objet ou entrer son numéro d'inventaire",
                "label": "Numéro d'inventaire",
                "notFoundError": "L'objet est inconnu"
              },
              "location": {
                "emptyError": "Sélectionnez une localisation",
                "label": "Destination d’arrivée",
                "notFoundError": "La localisation est inconnue"
              },
              "submit": "Ajouter",
              "submitting": "Ajout..."
            },
            "modal": {
              "title": "Ajouter un objet"
            }
          },
          "closeMovement": {
            "form": {
              "location": {
                "inputPlaceholder": "Entrez une localisation...",
                "noResult": "Aucun résultat"
              }
            }
          }
        },
        "firewall": {
          "collabWarningMessage": "Votre compte n'a pas de collaborateur associé, l'application peut dysfonctionner",
          "noGroupForUserWarningMessage": "L'usage de SKINreporter requiert que votre compte utilisateur soit lié à un groupe d'utilisateurs"
        },
        genericEditScreen: {
          genericErrorMsg: "Une erreur s'est produite",
          saveErrorMsg: "Échec lors de la sauvegarde des modifications",
          saveSuccessMsg: "Sauvegarde des modifications réussie",
        },
        "maskFields": {
          "boolean": {
            "no": "Non",
            "undefined": "Non défini",
            "yes": "Oui"
          },
          "entitySelect": {
            "modalPlaceholder": "Mots clés ou identifiants..."
          }
        },
        "editItemScreen": {
          "author": "Auteur",
          "inventoryNumber": "N° d'inventaire",
          "confirmButton": "Valider",
          "editButton": "Modifier",
          "saveNotification": {
            "errorMessage": "Une erreur est survenue pendant la sauvegarde de l'objet",
            "successMessage": "L'objet a été sauvegardé avec succès"
          },
          sections: {
            creation: "Création",
            description: "Description",
            identification: "Identification",
            location: "Localisation",
            notes: "Notes",
            state: "État",
          },
          "deleteNotification": {
            "errorMessage": "Une erreur est survenue pendant la suppression de l'objet non synchronisé",
            "successMessage": "L'objet a été supprimé avec succès"
          },
          "deleteModificationsNotification": {
            "errorMessage": "Une erreur est survenue pendant la suppression des modifications non synchronisées",
            "successMessage": "Les modifications ont été annulées"
          },
          "errorMessages": {
            "inventoryNumberNotUnique": "Ce numéro d'inventaire est déjà attribué"
          },
          fieldDisabledOffline: "La saisie de ce champ n'est pas disponible en mode hors-ligne",
          "menu": {
            "saveModifications": "Sauvegarder les modifications",
            "deleteNotSynchronizedNewItem": "Supprimer le nouvel objet",
            "deleteModificationsNotSynchronized": "Supprimer les modifications non synchronisées",
            "offlineWarning": "Les modifications sont sauvegardées sur l'appareil, vous devrez les synchroniser avec la base de données lorsque le réseau sera de nouveau disponible.",
            "offlineShortWarning": "Modifié sur cet appareil",
            "addToCampaign": "Récoler cet objet"
          }
        },
        "editRecordScreen": {
          "auditDate": "Date de récolement",
          fieldDisabledOffline: "La saisie de ce champ n'est pas disponible en mode hors-ligne",
          "foldAll": "Réduire tout",
          "itemNotice": "Fiche objet",
          "linkedObject": "Objet lié",
          "realTimeLocation": "Localisation en temps réel",
          "recordStatus": "Statut de la fiche",
          "unfoldAll": "Déployer tout",
          "medias": {
            "accordionPanelTitle": "MÉDIAS"
          },
          "menu": {
            "saveModifications": "Sauvegarder les modifications",
            "changeRecordStatus": "Modifier le statut de la fiche",
            "statusModificationWarning": "Confirmer la modification ?",
            "offlineWarning": "Les modifications sont sauvegardées sur l'appareil, vous devrez les synchroniser avec la base de données lorsque le réseau sera de nouveau disponible.",
            "offlineShortWarning": "Modifié sur cet appareil"
          },
          "notifications": {
            "saveError": "Une erreur est survenue lors de la sauvegarde",
            "saveSuccess": "Fiche de récolement sauvegardée",
            "stateTransitionError": "Une erreur est survenue pendant la modification du statu de la fiche",
            "stateTransitionSuccess": "Statut de la fiche modifié avec succès"
          }
        },
        "defectTree": {
          "annotation": {
            "deleteConfirmationMessage": "Confirmer la suppression ?",
            "defaultImageConfirmationMessage": "Définir comme image par défaut ?"
          }
        },
        "itemSearchScreen": {
          "camera": "APPAREIL PHOTO",
          "modifyRecord": "MODIFIER LA FICHE OBJET",
          "createNewItem": "CRÉER UN NOUVEL OBJET"
        },
        "searchFeaturedCard": {
          "institutionLabel": "Institution"
        },
        selectItemErrorDialog: {
          cancel: "Abandonner l'objet",
          cancelAll: "Abandonner tous les objets",
          description: "La sélection de {0} objets a échoué.",
          retry: "Réessayer pour cet objet",
          retryAll: "Réessayer pour tous les objets",
          title: "Échec lors de la sélection des images",
        },
        "auditCampaignSearchScreen": {
          "inProgress": "En cours",
          "title": "Projets de pointage/récolement en cours",
          "noResultsPlaceholder": "Vous n'êtes habilités à travailler sur aucune campagne pour le moment"
        },
        "recordSearchScreen": {
          "auditors": "Récoleurs",
          "campaignManager": "Responsable de la campagne",
          "inventoryNumber": "N° d'inventaire",
          "projectCreationDate": "Date de création du projet",
          "projectType": "Type de projet",
          "realTimeLocation": "Localisation en temps réel",
          "recordRefNumber": "Référence fiche",
          "status": "Statut",
          "title": "Fiches de récolement",
          "unknowLocation": "Localisation Inconnue",
          "menu": {
            "addItem": "Ajouter un objet"
          }
        },
        "state": {
          "all": "Tous",
          "archived": "Archivé",
          "canceled": "Annulé",
          "finalized": "Terminé",
          "inPreparation": "En préparation",
          "inProgress": "En cours",
          "programmed": "Planifié",
          "toValidated": "À valider",
          "validated": "Validé",
          "aborted": "Interrompue",
          "success": "Terminée avec succès",
          "error": "Erreur",
          "none": "Aucune synchronisation précédente"
        },
        "time": {
          "hours": "heure(s)",
          "minutes": "minute(s)",
          "seconds": "seconde(s)"
        },
        "locationSelector": {
          "inputPlaceholder": "Entrez une localisation",
          "title": "Choisissez une localisation",
          "validate": "Valider"
        },
        "synchroModal": {
          "title": "Synchronisation",
          "lastFetch": "Dernière récupération",
          "duration": "Durée",
          "status": "Statut",
          "details": "Détails",
          "lastSynchro": "Dernière synchronisation",
          "noEntityToSync": "Aucune entité à synchroniser",
          "connectionWarningPrefix": "Vous devez être connecté à internet pour pouvoir",
          "connectWarningSend": "envoyer",
          "connectWarningRetrieve": "récupérer",
          "connectionWarningSuffix": "des données",
          "noDataToSync": "Aucune donnée à synchroniser pour le moment",
          "localIconInfoPrefix": "L'icône",
          "localIconInfoSuffix": " indique que les données correspondantes ont été modifiées localement et devront être synchronisées avec la base de données distante.",
          "retrieveAll": "Tout récupérer",
          "finishedSynchros": "synchronisations terminées",
          "syncAll": "Tout synchroniser",
          "remainsToSynchronize": "Reste à synchroniser",
          "cleanImageCache": "Supprimer les images fantômes du cache",
          "cachedImagedCleaned": "Les images fantômes ont été supprimées !",
          "cleanCacheDown": "Vider le cache",
          "cacheDownCleaned": "Le cache a été vidé",
          "cleanCacheUp": "Supprimer toutes les modifications non synchronisées",
          "cacheUpCleaned": "Toute les modifications non synchronisées ont étés supprimées"
        },
        "entityNames": {
          "items": "Items",
          archives: "Archives",
          "auditRecords": "Fiches de récolement",
          "audits": "Projets de récolement",
          "thesaurusTerms": "Termes de thésaurus",
          "thesaurus": "Thésaurus",
          "entityFields": "Données système",
          "collaborators": "Collaborateurs",
          "authorities": "Autorités",
          "aliases": "Alias",
          "locations": "Localisations",
          "works": "Oeuvres",
          "expressions": "Expressions",
          "manifestations": "Manifestations",
          "specimens": "Spécimens"
        },
        "search": {
          "options": {
            "sortType": {
              "auditType": "Type de projet",
              "campaignCreationDate": "Date de création de la campagne",
              "creationDate": "Date de création",
              "identificationNumber": "Numéro d'identification",
              "identifier": "Identifiant principal",
              "lastModification": "Dernière modification",
              "mainTitle": "Titre principal",
              "referenceNumber": "Numéro de référence"
            }
          },
          "queryPlaceholder": "Mots clés ou N° de campagne",
          "totalCount": "{totalResults}  Résultat(s) : 1 -",
          "noResults": "Aucun résultat",
          "title": "Objets de musée"
        },
        "itemCreationImagePopup": {
          "title": "Ajouter une image",
          "addImage": "AJOUTER UNE IMAGE",
          "ignore": "PLUS TARD, IGNORER CETTE ETAPE"
        },
        uploadImageFailureDialog: {
          cancel: "Abandonner l'image {0}",
          cancelAll: "Abandonner toutes les images",
          description: "Le téléversement de {0} images a échoué.",
          imageAndNumber: "Image {0}",
          retry: "Réessayer pour l'image {0}",
          retryAll: "Réessayer pour toutes les images",
          title: "Échec lors du téléversement des images",
        },
        "SpecimenSearchScreen": {
          "createNewSpecimen": "CRÉER UN NOUVEAU SPÉCIMEN"
        }
    },
    "fr-DIOR": {
      
    },
    "fr-ca": {
        "countryCode": "ca",
        "alerts": {
          "workspace": {
            "unableToChangeWorkspace": "Échec du changement d'espace de travail",
            "unableToLoadWorkspace": "Le chargement de l'espace de travail a échoué",
          },
          "permissions": {
            "camera": {
              askForPermission: "SKR-Audit a besoin de la permission d'accéder à la caméra. Cette permission est nécessaire pour les fonctionnalités de scan de code-barre/QR-code. Sans cette permission ces fonctionnalités ne pourront être assurées.",
              permissionDeniedWarning: "La permission d'accéder à la caméra a été refusée à SKR-Audit auparavant. Les fonctionnalités de scan de code-barre/QR-code ne sont donc pas disponible. Pour pouvoir y accéder, merci d'autoriser manuellement l'accès à la caméra pour SKR-Audit.",
            }
          },
          "medias": {
            "failUpload": "Échec du téléversement du média.",
            "failGetIdFromFileName": "Le média a été téléversé, mais Skin-Reporter ne parvient pas à le trouver.",
          },
        },
        "auth": {
          "login": {
            "error": {
              "credentials": "Vos identifiants sont incorrects",
              "network": "La communication avec le serveur a échoué"
            },
            "form": {
              "password": {
                "error": "Veuillez saisir votre nom d'utilisateur",
                "label": "Mot de passe"
              },
              "submit": "Se connecter",
              "submitting": "Connexion...",
              "username": {
                "error": "Veuillez saisir votre mot de passe",
                "label": "Nom d'utilisateur"
              }
            }
          },
          "renew": {
            "slowNetwork": "Cela semble mettre plus de temps que d'habitude, ne quittez pas l'application.",
            "spinner": "Nous vous reconnectons..."
          },
          sso: {
            errors: {
              authenticationFailed: "Erreur : impossible de finaliser l'authentification."
            },
            selectIDP: "S'authentifier avec...",
            otherIDPs: "Autres types de comptes",
          },
        },
        "actionBar": {
          "newItems": "Nouveaux objets",
          "auditCampaign": "Campagnes de récolement",
          "synchro": "Synchro"
        },
        autoCompleteTextField: {
          modal: {
            okButton: "Ok",
          },
        },
        "cameraScanner": {
          "scanCode": "Scanner un code-barre",
          "cancel": "Annuler",
          errors: {
            cameraNotFound: "Aucune caméra n'a été détectée",
          },
        },
        "navbar": {
          "contextMenuModal": {
            "buildDate": "Déployé le",
            "checkForUpdate": {
              "help": "Si une mise à jour est disponible, elle s'installera automatiquement.",
              "title": "Vérifiez les mises à jour"
            },
            "clearCache": {
              "help": "Si vous êtes hors-ligne, cela supprime l'accès à toutes les données stockées sur l'appareil.",
              "title": "Vider le cache"
            },
            "overrideLocale": {
              "help": "La langue anglaise sera utilisée et le paramétrage de votre terminal ignoré.",
              "title": "Forcer la langue anglaise"
            },
            "resetLocaleOverride": {
              "help": "La langue utilisé dépendra du paramètrage de votre terminal",
              "title": "Réinitialiser la langue"
            },
            "serviceWorker": {
              help: "Le bandeau de mise à jour s'affiche continuellement ? Cliquez ici !",
              title: "Fermer le bandeau de mise à jour",
            },
            "title": "Skin-REPORTER",
            "version": "version",
          },
          "logout": "Etes-vous sûr de vouloir vous déconnecter ?"
        },
        "offlineRibbon": {
          "offline": "Vous êtes hors connexion",
          "online": "Vous êtes connecté"
        },
        "proxy": {
          "error": {
            "default": "Une erreur s'est produite sur la ressource {uri}",
            "network": "La communication avec le serveur a échoué",
            "notFound": "La ressource {uri} n'a pas été trouvée",
            "tokenHasExpired": "Votre session a expiré"
          }
        },
        "serviceWorker": {
          "updateAvailable": "Une mise à jour a été installée. Cliquez ici pour recharger la page ou relancez l'application",
          forceServiceWorkerUpdate: {
            modalTitle: "Résolution du problème",
            versionCorrect: "Les informations ci-dessous correspondent-elles à la version et la date transmises par SKINsoft après la dernière mise à jour ?",
            yes: "Oui",
            no: "Non",
          },
        },
        "itemCard": {
          "detailsNotAvailable": "Détails non disponible",
          "error": "L'objet ne peut pas être affiché",
          "identifier": "N° Inv. {identifier}",
          "identifierError": "Erreur d'identification",
          "location": "Localisation",
          "locationLabel": "Destination: <strong>{title}</strong>",
          "unknownLocation": "Inconnue",
          "title": "Titre",
          "locationSelector": {
            "title": "Choisissez une localisation",
            "validate": "Valider"
          }
        },
        "entity": {
          "addItem": {
            "error": {
              "api": "L'objet n'a pas pu être ajouté",
              "network": "La communication avec le serveur a échoué"
            },
            "form": {
              "id": {
                "alreadyAdded": "L'objet est déjà existant dans le mouvement",
                "emptyError": "Veuillez scanner un objet ou entrer son numéro d'inventaire",
                "label": "Numéro d'inventaire",
                "notFoundError": "L'objet est inconnu"
              },
              "location": {
                "emptyError": "Sélectionnez une localisation",
                "label": "Destination d’arrivée",
                "notFoundError": "La localisation est inconnue"
              },
              "submit": "Ajouter",
              "submitting": "Ajout..."
            },
            "modal": {
              "title": "Ajouter un objet"
            }
          },
          "closeMovement": {
            "form": {
              "location": {
                "inputPlaceholder": "Entrez une localisation...",
                "noResult": "Aucun résultat"
              }
            }
          }
        },
        "firewall": {
          "collabWarningMessage": "Votre compte n'a pas de collaborateur associé, l'application peut dysfonctionner",
          "noGroupForUserWarningMessage": "L'usage de SKINreporter requiert que votre compte utilisateur soit lié à un groupe d'utilisateurs"
        },
        "maskFields": {
          "boolean": {
            "no": "Non",
            "undefined": "Non défini",
            "yes": "Oui"
          },
          "entitySelect": {
            "modalPlaceholder": "Mots clés ou identifiants..."
          }
        },
        "editItemScreen": {
          "author": "Auteur",
          "inventoryNumber": "N° d'inventaire",
          "confirmButton": "Valider",
          "editButton": "Modifier",
          "saveNotification": {
            "errorMessage": "Une erreur est survenue pendant la sauvegarde de l'objet",
            "successMessage": "L'objet a été sauvegardé avec succès"
          },
          sections: {
            creation: "Création",
            description: "Description",
            identification: "Identification",
            location: "Localisation",
            notes: "Notes",
            state: "État",
          },
          "deleteNotification": {
            "errorMessage": "Une erreur est survenue pendant la suppression de l'objet non synchronisés",
            "successMessage": "L'objet a été supprimé avec succès"
          },
          "deleteModificationsNotification": {
            "errorMessage": "Une erreur est survenue pendant la suppression des modifications non synchronisées",
            "successMessage": "Les modifications ont été annulées"
          },
          "errorMessages": {
            "inventoryNumberNotUnique": "Ce numéro d'inventaire est déjà attribué"
          },
          fieldDisabledOffline: "La saisie de ce champ n'est pas disponible en mode hors-ligne",
          "menu": {
            "saveModifications": "Sauvegarder les modifications",
            "deleteNotSynchronizedNewItem": "Supprimer le nouvel objet",
            "deleteModificationsNotSynchronized": "Supprimer les modifications non synchronisées",
            "offlineWarning": "Les modifications sont sauvegardées sur l'appareil, vous devrez les synchroniser avec la base de données lorsque le réseau sera de nouveau disponible.",
            "offlineShortWarning": "Modifié sur cet appareil",
            "addToCampaign": "Récoler cet objet"
          }
        },
        "editRecordScreen": {
          "auditDate": "Date de récolement",
          fieldDisabledOffline: "La saisie de ce champ n'est pas disponible en mode hors-ligne",
          "itemNotice": "Fiche objet",
          "foldAll": "Réduire tout",
          "linkedObject": "Objet lié",
          "realTimeLocation": "Localisation en temps réel",
          "recordStatus": "Statut de la fiche",
          "unfoldAll": "Déployer tout",
          "medias": {
            "accordionPanelTitle": "MÉDIAS"
          },
          "menu": {
            "saveModifications": "Sauvegarder les modifications",
            "changeRecordStatus": "Modifier le statut de la fiche",
            "statusModificationWarning": "Confirmer la modification ?",
            "offlineWarning": "Les modifications sont sauvegardées sur l'appareil, vous devrez les synchroniser avec la base de données lorsque le réseau sera de nouveau disponible.",
            "offlineShortWarning": "Modifié sur cet appareil"
          },
          "notifications": {
            "saveError": "Une erreur est survenue lors de la sauvegarde",
            "saveSuccess": "Fiche de récolement sauvegardée",
            "stateTransitionError": "Une erreur est survenue pendant la modification du statu de la fiche",
            "stateTransitionSuccess": "Statut de la fiche modifié avec succès",
            "addToCampaign": "Récoler cet objet"
          }
        },
        "defectTree": {
          "annotation": {
            "deleteConfirmationMessage": "Confirmer la suppression ?",
            "defaultImageConfirmationMessage": "Définir comme image par défaut ?"
          }
        },
        "itemSearchScreen": {
          "camera": "APPAREIL PHOTO",
          "modifyRecord": "MODIFIER LA FICHE OBJET",
          "createNewItem": "CRÉER UN NOUVEL OBJET"
        },
        "searchFeaturedCard": {
          "institutionLabel": "Institution"
        },
        selectItemErrorDialog: {
          cancel: "Abandonner l'objet",
          cancelAll: "Abandonner tous les objets",
          description: "La sélection de {0} objets a échoué.",
          retry: "Réessayer pour cet objet",
          retryAll: "Réessayer pour tous les objets",
          title: "Échec lors de la sélection des images",
        },
        "auditCampaignSearchScreen": {
          "inProgress": "En cours",
          "title": "Projets de pointage/récolement en cours",
          "noResultsPlaceholder": "Vous n'êtes habilités à travailler sur aucune campagne pour le moment"
        },
        "recordSearchScreen": {
          "auditors": "Récoleurs",
          "campaignManager": "Responsable de la campagne",
          "inventoryNumber": "N° d'inventaire",
          "projectCreationDate": "Date de création du projet",
          "projectType": "Type de projet",
          "realTimeLocation": "Localisation en temps réel",
          "recordRefNumber": "Référence fiche",
          "status": "Statut",
          "title": "Fiches de récolement",
          "unknowLocation": "Localisation Inconnue",
          "menu": {
            "addItem": "Ajouter un objet"
          }
        },
        "state": {
          "all": "Tous",
          "archived": "Archivé",
          "canceled": "Annulé",
          "finalized": "Terminé",
          "inPreparation": "En préparation",
          "inProgress": "En cours",
          "programmed": "Planifié",
          "toValidated": "À valider",
          "validated": "Validé",
          "aborted": "Interrompue",
          "success": "Terminée avec succès",
          "error": "Erreur",
          "none": "Aucune synchronisation précédente"
        },
        "time": {
          "hours": "heure(s)",
          "minutes": "minute(s)",
          "seconds": "seconde(s)"
        },
        "locationSelector": {
          "inputPlaceholder": "Entrez une localisation",
          "title": "Choisissez une localisation",
          "validate": "Valider"
        },
        "synchroModal": {
          "title": "Synchronisation",
          "lastFetch": "Dernière récupération",
          "duration": "Durée",
          "status": "Statut",
          "details": "Détails",
          "lastSynchro": "Dernière synchronisation",
          "noEntityToSync": "Aucune entité à synchroniser",
          "connectionWarningPrefix": "Vous devez être connecté à internet pour pouvoir",
          "connectWarningSend": "envoyer",
          "connectWarningRetrieve": "récupérer",
          "connectionWarningSuffix": "des données",
          "noDataToSync": "Aucune donnée à synchroniser pour le moment",
          "localIconInfoPrefix": "L'icône",
          "localIconInfoSuffix": " indique que les données correspondantes ont été modifiées localement et devront être synchronisées avec la base de données distante.",
          "retrieveAll": "Tout récupérer",
          "finishedSynchros": "synchronisations terminées",
          "syncAll": "Tout synchroniser",
          "remainsToSynchronize": "Reste à synchroniser",
          "cleanImageCache": "Supprimer les images fantômes du cache",
          "cachedImagedCleaned": "Les images fantômes ont été supprimées !",
          "cleanCacheDown": "Vider le cache",
          "cacheDownCleaned": "Le cache a été vidé",
          "cleanCacheUp": "Supprimer toutes les modifications non synchronisées",
          "cacheUpCleaned": "Toute les modifications non synchronisées ont étés supprimées"
        },
        "entityNames": {
          "items": "Items",
          "auditRecords": "Fiches de récolement",
          "audits": "Projets de récolement",
          "thesaurusTerms": "Termes de thésaurus",
          "thesaurus": "Thésaurus",
          "entityFields": "Données système",
          "collaborators": "Collaborateurs",
          "authorities": "Autorités",
          "aliases": "Alias",
          "locations": "Localisations",
          "works": "Oeuvres",
          "expressions": "Expressions",
          "manifestations": "Manifestations",
          "specimens": "Spécimens"
        },
        "search": {
          "options": {
            "sortType": {
              "auditType": "Type de projet",
              "campaignCreationDate": "Date de création de la campagne",
              "identificationNumber": "Numéro d'identification",
              "creationDate": "Date de création",
              "identifier": "Identifiant principal",
              "lastModification": "Dernière modification",
              "mainTitle": "Titre principal",
              "referenceNumber": "Numéro de référence"
            }
          },
          "queryPlaceholder": "Mots clés ou N° de campagne",
          "totalCount": "{totalResults}  Résultat(s) : 1 -",
          "noResults": "Aucun résultat",
          "title": "Objets de musée"
        },
        "itemCreationImagePopup": {
          "title": "Ajouter une image",
          "addImage": "AJOUTER UNE IMAGE",
          "ignore": "PLUS TARD, IGNORER CETTE ETAPE"
        },
        uploadImageFailureDialog: {
          cancel: "Abandonner l'image {0}",
          cancelAll: "Abandonner toutes les images",
          description: "Le téléversement de {0} images a échoué.",
          imageAndNumber: "Image {0}",
          retry: "Réessayer pour l'image {0}",
          retryAll: "Réessayer pour toutes les images",
          title: "Échec lors du téléversement des images",
        },
        "SpecimenSearchScreen": {
          "createNewSpecimen": "CRÉER UN NOUVEAU SPÉCIMEN"
        }
    },
    "nl": {
        "countryCode": "nl",
        "alerts": {
          "workspace": {
            "unableToChangeWorkspace": "Niet gelukt om werkruimte te wijzigen",
            "unableToLoadWorkspace": "Laden van werkruimte mislukt",
          },
          "permissions": {
            "camera": {
              askForPermission: "SKR-Audit heeft toestemming nodig voor toegang tot de camera. Deze toestemming is nodig voor de barcode/QR-code scanfuncties. Zonder deze toestemming kunnen deze functies niet worden geleverd.",
              permissionDeniedWarning: "Toegang tot de camera is eerder geweigerd aan SKR-Audit. Barcode/QR-code scanfunctionaliteiten zijn daarom niet beschikbaar. Geef SKR-Audit handmatig toegang tot de camera om deze toch te kunnen gebruiken.",
            }
          },
          "medias": {
            "failUpload": "Het uploaden van de media is mislukt.",
            "failGetIdFromFileName": "De media is geüpload, maar Skin-Reporter kan het niet vinden.",
          },
        },
        archiveEditScreen: {
          saveAlert: {
            errorMessage: "MISSING TRANSLATION",
            successMessage: "MISSING TRANSLATION",
          },
        },
        archiveEditScreenHeader: {
          cote: "MISSING TRANSLATION",
          descriptionLevel: "MISSING TRANSLATION",
        },
        archiveSearchScreen: {
          createNewArchive: "MISSING TRANSLATION",
        },
        "auth": {
          "login": {
            "error": {
              "credentials": "Gebruikersnaam en/of paswoord incorrect",
              "network": "Communicatie met server mislukt"
            },
            "form": {
              "password": {
                "error": "Gelieve uw gebruikersnaam in te geven",
                "label": "Paswoord"
              },
              "submit": "Inloggen",
              "submitting": "Inloggen…",
              "username": {
                "error": "Gelieve uw paswoord in te geven",
                "label": "Gebruikersnaam"
              }
            }
          },
          "renew": {
            "slowNetwork": "Dit lijkt langer te duren dan normaal. Gelieve de toepassing niet te sluiten.",
            "spinner": "Opnieuw online brengen…"
          },
          sso: {
            errors: {
              authenticationFailed: "Error: authentificatie kon niet worden voltooid."
            },
            selectIDP: "Inloggen met…",
            otherIDPs: "Andere accounttypes",
          },
        },
        "actionBar": {
          "newItems": "Nieuwe items",
          "auditCampaign": "Inventariscampagnes",
          "synchro": "Synchro"
        },
        autoCompleteTextField: {
          modal: {
            okButton: "Ok",
          },
        },
        "cameraScanner": {
          "scanCode": "Scan de streepjescode",
          "cancel": "Annuleren",
          errors: {
            cameraNotFound: "Geen camera's gedetecteerd",
          },
        },
        createArchiveModal: {
          creationFailed: "MISSING TRANSLATION",
          descriptionLevel: "MISSING TRANSLATION",
          submitBtn: "MISSING TRANSLATION",
          submitting: "MISSING TRANSLATION",
          title: "MISSING TRANSLATION",
        },
        "navbar": {
          "contextMenuModal": {
            "buildDate": "Ingebruikname op",
            "checkForUpdate": {
              "help": "Als een update beschikbaar is, zal die automatisch worden geïnstalleerd",
              "title": "Controleer op updates"
            },
            "clearCache": {
              "help": "Als u offline bent, heeft u niet langer toegang tot de gegevens die zijn opgeslagen op het toestel.",
              "title": "Cachegeheugen leegmaken"
            },
            "overrideLocale": {
              "help": "Het Engels zal worden gebruikt en de instellingen van uw toestel zullen worden genegeerd.",
              "title": "Leg Engelse taal op"
            },
            "resetLocaleOverride": {
              "help": "De taal hangt af van de instellingen van uw toestel",
              "title": "Reset taal"
            },
            "serviceWorker": {
              help: "Blijft het updatebanner verschijnen? Klik hier!",
              title: "Sluit de updatebanner",
            },
            "title": "Skin-REPORTER",
            "version": "versie",
          },
          "logout": "Bent u zeker dat u wil uitloggen?"
        },
        "offlineRibbon": {
          "offline": "U bent nu offline",
          "online": "U bent nu online"
        },
        "proxy": {
          "error": {
            "default": "Er is een fout opgetreden in de bron {uri}",
            "network": "Communicatie met server mislukt",
            "notFound": "De bron {uri} kon niet worden gevonden",
            "tokenHasExpired": "Uw sessie is vervallen"
          }
        },
        "serviceWorker": {
          "updateAvailable": "Er werd een update geïnstalleerd. Klik hier om de pagina opnieuw te laden of de toepassing te herstarten.",
          forceServiceWorkerUpdate: {
            modalTitle: "Het probleem oplossen",
            versionCorrect: "Komen de onderstaande gegevens overeen met de versie en datum die door SKINsoft zijn verstrekt na de laatste update ?",
            "yes": "Ja",
            "no": "Nee",
          },
        },
        "itemCard": {
          "detailsNotAvailable": "Geen details beschikbaar",
          "error": "Het item kan niet worden weergegeven",
          "identifier": "N° Inv. {identifier}",
          "identifierError": "Identificatiefout",
          "location": "Locatie",
          "locationLabel": "Bestemming: <strong>{title}</strong>",
          "unknownLocation": "Onbekend",
          "title": "Titel",
          "locationSelector": {
            "title": "Selecteer locatie",
            "validate": "Valideer"
          }
        },
        "entity": {
          "addItem": {
            "error": {
              "api": "Het object kon niet worden toegevoegd",
              "network": "Communicatie met server mislukt"
            },
            "form": {
              "id": {
                "alreadyAdded": "Het object bestaat reeds in deze selectie",
                "emptyError": "Gelieve een item te scannen of zijn inventarisnummer in te geven",
                "label": "Inventarisnummer",
                "notFoundError": "Onbekend item"
              },
              "location": {
                "emptyError": "Selecteer locatie",
                "label": "Aankomstlocatie",
                "notFoundError": "Onbekende locatie"
              },
              "submit": "Voeg toe",
              "submitting": "Toevoegen…"
            },
            "modal": {
              "title": "Voeg item toe"
            }
          },
          "closeMovement": {
            "form": {
              "location": {
                "inputPlaceholder": "Selecteer locatie",
                "noResult": "Geen resultaat"
              }
            }
          }
        },
        "firewall": {
          "collabWarningMessage": "Er is geen medewerker gelinkt aan uw account, de toepassing kan minder goed werken",
          "noGroupForUserWarningMessage": "Om SKIN-reporter te kunnen gebruiken moet uw gebruikersaccount gelinkt zijn aan een gebruikersgroep"
        },
        genericEditScreen: {
          genericErrorMsg: "MISSING TRANSLATION",
          saveErrorMsg: "MISSING TRANSLATION",
          saveSuccessMsg: "MISSING TRANSLATION",
        },
        "maskFields": {
          "boolean": {
            "no": "Nee",
            "undefined": "Ongedefinieerd",
            "yes": "Ja"
          },
          "entitySelect": {
            "modalPlaceholder": "Trefwoorden of identificatoren"
          }
        },
        "editItemScreen": {
          "author": "Auteur",
          "inventoryNumber": "Inventarisnummer",
          "confirmButton": "Bevestig",
          "editButton": "Aanpassen",
          "saveNotification": {
            "errorMessage": "Er is een fout opgetreden tijdens het opslaan van het object",
            "successMessage": "Het object is succesvol opgeslagen"
          },
          sections: {
            creation: "Aanmaak",
            description: "Beschrijving",
            identification: "Identificatie",
            location: "Locatie",
            notes: "Opmerkingen",
            state: "Status",
          },
          "deleteNotification": {
            "errorMessage": "Er is een fout opgetreden bij het verwijderen van het niet-gesynchroniseerde item",
            "successMessage": "Item succesvol verwijderd"
          },
          "deleteModificationsNotification": {
            "errorMessage": "Er is een fout opgetreden bij het verwijderen van niet-gesynchroniseerde wijzigingen",
            "successMessage": "De wijzigingen werden geannuleerd"
          },
          "errorMessages": {
            "inventoryNumberNotUnique": "Dit inventarisnummer is al toegewezen"
          },
          fieldDisabledOffline: "Dit veld is niet beschikbaar in offline modus",
          "menu": {
            "saveModifications": "Save modifications",
            "deleteNotSynchronizedNewItem": "Het nieuwe object verwijderen",
            "deleteModificationsNotSynchronized": "Niet gesynchroniseerde wijzigingen verwijderen",
            "offlineWarning": "Modifications are saved on this device, you will have to synchronize them with the database when the network is back.",
            "offlineShortWarning": "Modified on this device",
            "addToCampaign": "Verzamel dit item"
          }
        },
        "editRecordScreen": {
          "auditDate": "Inventarisatiedatum",
          fieldDisabledOffline: "Dit veld is niet beschikbaar in offline modus",
          "foldAll": "Verminder alle",
          "itemNotice": "Ga naar item",
          "linkedObject": "Gelinkt item",
          "realTimeLocation": "Locatie in realtime",
          "recordStatus": "Status van de fiche",
          "unfoldAll": "Zet alle",
          "medias": {
            "accordionPanelTitle": "MEDIA'S"
          },
          "menu": {
            "saveModifications": "Bewaar wijzigingen",
            "changeRecordStatus": "Wijzig status van de fiche",
            "statusModificationWarning": "Wijziging bevestigen?",
            "offlineWarning": "De wijzigingen worden op het toestel bewaard. U moet ze synchroniseren met de databank wanneer het netwerk opnieuw beschikbaar is.",
            "offlineShortWarning": "Gewijzigd op dit toestel"
          },
          "notifications": {
            "saveError": "Er is een fout opgetreden bij het bewaren",
            "saveSuccess": "Inventarisfiche bewaard",
            "stateTransitionError": "Er is een fout opgetreden bij het wijzigen van de status van de fiche",
            "stateTransitionSuccess": "Status van de fiche met succes gewijzigd"
          }
        },
        "defectTree": {
          "annotation": {
            "deleteConfirmationMessage": "Verwijdering bevestigen?",
            "defaultImageConfirmationMessage": "Instellen als defaultbeeld?"
          }
        },
        "itemSearchScreen": {
          "camera": "FOTOTOESTEL",
          "modifyRecord": " ITEMFICHE WIJZIGEN",
          "createNewItem": "MAAK NIEUW ITEM AAN"
        },
        "searchFeaturedCard": {
          "institutionLabel": "Instelling"
        },
        selectItemErrorDialog: {
          cancel: "Object afbreken",
          cancelAll: "Alle objecten afbreken",
          description: "De selectie van {0} objecten is mislukt.",
          retry: "Herhaal voor dit object",
          retryAll: "Herhaal voor alle objecten",
          title: "Mislukt bij het selecteren van afbeeldingen",
        },
        "auditCampaignSearchScreen": {
          "inProgress": "In uitvoering",
          "title": "Inventarisatie in uitvoering",
          "noResultsPlaceholder": "Op dit ogenblik bent u niet bevoegd om te werken aan een campagne"
        },
        "recordSearchScreen": {
          "auditors": "Medewerkers inventarisering",
          "campaignManager": "Coördinator van de campagne",
          "inventoryNumber": "Inventarisnummer",
          "projectCreationDate": "Aanmaakdatum van het project",
          "projectType": "Soort project",
          "realTimeLocation": "Locatie in realtime",
          "recordRefNumber": "Referentienummer van de fiche",
          "status": "Status",
          "title": "Inventarisfiches",
          "unknowLocation": "Onbekende locatie",
          "menu": {
            "addItem": "Voeg item toe"
          }
        },
        "state": {
          "all": "Alle",
          "archived": "Gearchiveerd",
          "canceled": "Geannuleerd",
          "finalized": "Beëindigd",
          "inPreparation": "In voorbereiding",
          "inProgress": "In uitvoering",
          "programmed": "Gepland",
          "toValidated": "Moet worden gevalideerd",
          "validated": "Gevalideerd",
          "aborted": "Afgebroken",
          "success": "Succesvol beëindigd",
          "error": "Fout",
          "none": "Geen voorgaande synchronisatie"
        },
        "time": {
          "hours": "uur/uren",
          "minutes": "minuut/minuten",
          "seconds": "seconde(n)"
        },
        "locationSelector": {
          "inputPlaceholder": "Soort locatie",
          "title": "Selecteer locatie",
          "validate": "Valideer"
        },
        "synchroModal": {
          "title": "Synchronisatie",
          "lastFetch": "Laatste recuperatie",
          "duration": "Duur",
          "status": "Status",
          "details": "Details",
          "lastSynchro": "Laaste synchronisatie",
          "noEntityToSync": "Niks om te synchroniseren",
          "connectionWarningPrefix": "U moet verbonden zijn met het internet om te",
          "connectWarningSend": "verzenden",
          "connectWarningRetrieve": "haal terug",
          "connectionWarningSuffix": "gegevens",
          "noDataToSync": "Geen gegevens om te synchroniseren op dit ogenblik",
          "localIconInfoPrefix": "Het icoon",
          "localIconInfoSuffix": "geeft aan dat de corresponderende gegevens lokaal zijn gewijzigd en moeten worden gesynchroniseerd met de databank.",
          "retrieveAll": "haal alles terug",
          "finishedSynchros": "Synchronisatie beëindigd",
          "syncAll": "Alles synchroniseren",
          "remainsToSynchronize": "Nog te synchroniseren",
          "cleanImageCache": "Spookafbeeldingen uit de cache verwijderen",
          "cachedImagedCleaned": "De spookbeelden zijn verwijderd!",
          "cleanCacheDown": "De cache wissen",
          "cacheDownCleaned": "De cache is geleegd!",
          "cleanCacheUp": "Alle niet gesynchroniseerde wijzigingen verwijderen",
          "cacheUpCleaned": "Alle niet gesynchroniseerde wijzigingen zijn verwijderd!"
        },
        "entityNames": {
          "items": "Items",
          archives: "MISSING TRANSLATION",
          "auditRecords": "Inventarisfiches",
          "audits": "Inventariscampagnes",
          "thesaurusTerms": "Thesaurusitems",
          "thesaurus": "Thesaurus",
          "entityFields": "Systeemgegevens",
          "collaborators": "Medewerkers",
          "authorities": "Autoriteiten",
          "aliases": "Aliassen",
          "locations": "Locaties",
          "works": "Werken",
          "expressions": "Expressies",
          "manifestations": "Verschijningsvormen",
          "specimens": "MISSING TRANSLATION"
        },
        "search": {
          "options": {
            "sortType": {
              "auditType": "Soort project",
              "campaignCreationDate": "Aanmaakdatum van de campagne",
              "identificationNumber": "Identificatienummer",
              "creationDate": "Creatiedatum",
              "identifier": "Hoofdidentificator",
              "lastModification": "Laaste wijziging",
              "mainTitle": "Hoofdtitel",
              "referenceNumber": "Referentienummer"
            }
          },
          "queryPlaceholder": "Trefwoorden of campangenummer",
          "totalCount": "{totalResults}  Resultaten: 1 -",
          "noResults": "Geen resultaat",
          "title": "Museumitems"
        },
        "itemCreationImagePopup": {
          "title": "Beeld toevoegen",
          "addImage": "BEELD TOEVOEGEN",
          "ignore": "LATER, NEGEER DEZE STAP"
        },
        uploadImageFailureDialog: {
          cancel: "Verlaat afbeelding {0}",
          cancelAll: "Verlaat alle afbeeldingen",
          description: "Het uploaden van {0} afbeeldingen is mislukt.",
          imageAndNumber: "Afbeelding {0}",
          retry: "Opnieuw proberen voor afbeelding {0}",
          retryAll: "Opnieuw proberen voor alle afbeeldingen",
          title: "Fout bij uploaden afbeelding",
        },
        "SpecimenSearchScreen": {
          "createNewSpecimen": "MISSING TRANSLATION"
        }
    },
    "es": {
      "countryCode": "es",
      "alerts": {
        "workspace": {
          "unableToChangeWorkspace": "Error al cambiar el espacio de trabajo",
          "unableToLoadWorkspace": "Error al cargar el espacio de trabajo"
        },
        "permissions": {
          "camera": {
            "askForPermission": "SKR-Audit necesita permiso para acceder a la cámara. Este permiso es necesario para las funciones de escaneo de códigos de barras/códigos QR. Sin este permiso no se pueden proporcionar estas funciones.",
            "permissionDeniedWarning": "El permiso de acceso a la cámara a SKR-Audit se ha negado previamente. Por lo tanto, las funciones de escaneo de códigos de barras/QR no están disponibles. Para poder acceder a ellas, autorice manualmente el acceso a la cámara para SKR-Audit."
          }
        },
        "medias": {
          "failUpload": "No se ha podido cargar el multimedia",
          "failGetIdFromFileName": "El multimedia se ha cargado, pero Skin-Reporter no puede encontrarlo",
        },
      },
      archiveEditScreen: {
        saveAlert: {
          errorMessage: "MISSING TRANSLATION",
          successMessage: "MISSING TRANSLATION",
        },
      },
      archiveEditScreenHeader: {
        cote: "MISSING TRANSLATION",
        descriptionLevel: "MISSING TRANSLATION",
      },
      archiveSearchScreen: {
        createNewArchive: "MISSING TRANSLATION",
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Sus datos de acceso son incorrectos",
            "network": "La comunicación con el servidor ha fallado"
          },
          "form": {
            "password": {
              "error": "Por favor, introduzca su nombre de usuario",
              "label": "Contraseña"
            },
            "submit": "Entrar en el sistema",
            "submitting": "Conectando...",
            "username": {
              "error": "Por favor, introduzca su contraseña",
              "label": "Nombre de usuario"
            }
          }
        },
        "renew": {
          "slowNetwork": "Si parece que tarda más de lo habitual, no abandones la aplicación.",
          "spinner": "Reconectando"
        },
        sso: {
          errors: {
            authenticationFailed: "Error: No se ha podido completar la autenticación"
          },
          selectIDP: "Autenticarse con...",
          otherIDPs: "Otros tipos de cuenta",
        },
      },
      "actionBar": {
        "newItems": "Nuevos objetos",
        "auditCampaign": "Campañas de auditoría",
        "synchro": "Sincronice"
      },
      autoCompleteTextField: {
        modal: {
          okButton: "OK",
        },
      },
      "cameraScanner": {
        "scanCode": "Escanear el código de barras",
        "cancel": "Cancelar",
        "errors": {
          "cameraNotFound": "No se ha detectado la cámara"
        }
      },
      createArchiveModal: {
        creationFailed: "MISSING TRANSLATION",
        descriptionLevel: "MISSING TRANSLATION",
        submitBtn: "MISSING TRANSLATION",
        submitting: "MISSING TRANSLATION",
        title: "MISSING TRANSLATION",
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Despliegue",
          "checkForUpdate": {
            "help": "Si hay una actualización disponible, se instalará automáticamente.",
            "title": "Comprobar las actualizaciones"
          },
          "clearCache": {
            "help": "Si está sin conexión, este proceso eliminará el acceso a todos los datos almacenados en el dispositivo.",
            "title": "Vaciar la memoria caché"
          },
          "overrideLocale": {
            "help": "Se utilizará el idioma inglés y no se tomará en cuenta la configuración de su dispositivo.",
            "title": "Forzar el idioma inglés"
          },
          "resetLocaleOverride": {
            "help": "El idioma dependerá de la configuración de su dispositivo",
            "title": "Restablecer el idioma"
          },
          "serviceWorker": {
            "help": "¿Se muestra continuamente el banner de actualización? ¡Haga clic aquí!",
            "title": "Cerrar el banner de actualización"
          },
          "title": "Skin-REPORTER",
          "version": "versión"
        },
        "logout": "¿Está seguro de que quiere desconectarse?"
      },
      "offlineRibbon": {
        "offline": "Está sin conexión ",
        "online": "Está conectado"
      },
      "proxy": {
        "error": {
          "default": "Se ha producido un error en el recurso {url}",
          "network": "La comunicación con el servidor ha fallado",
          "notFound": "No se ha encontrado el recurso {url}",
          "tokenHasExpired": "Su sesión ha expirado"
        }
      },
      "serviceWorker": {
        "updateAvailable": "Se ha instalado una actualización. Pulse aquí para actualizar la página o reiniciar la aplicación",
        "forceServiceWorkerUpdate": {
          "modalTitle": "Resolución del problema",
          "versionCorrect": "¿La versión que se muestra coincide con el número de versión y la fecha que SKINsoft envió después de la actualización ?",
          "yes": "Sí",
          "no": "No"
        }
      },
      "itemCard": {
        "detailsNotAvailable": "Detalles no disponibles",
        "error": "El objeto no se puede mostrar",
        "identifier": "Nº de inventario {identificador}",
        "identifierError": "Identificador erróneo",
        "location": "Ubicación",
        "locationLabel": "Destino: <strong>{title}</strong>",
        "unknownLocation": "Desconocido",
        "title": "Título",
        "locationSelector": {
          "title": "Seleccionar una ubicación",
          "validate": "Validar"
        }
      },
      "entity": {
        "addItem": {
          "error": {
            "api": "No se ha podido añadir el objeto",
            "network": "La comunicación con el servidor ha fallado"
          },
          "form": {
            "id": {
              "alreadyAdded": "El objeto ya existe en el movimiento",
              "emptyError": "Por favor, escanee un artículo o introduzca su número de inventario",
              "label": "Número de inventario",
              "notFoundError": "El objeto es desconocido"
            },
            "location": {
              "emptyError": "Seleccione una ubicación",
              "label": "Ubicación de llegada",
              "notFoundError": "La ubicación es desconocida"
            },
            "submit": "Añadir",
            "submitting": "Añadiendo..."
          },
          "modal": {
            "title": "Añadir un objeto"
          }
        },
        "closeMovement": {
          "form": {
            "location": {
              "inputPlaceholder": "Introduzca una ubicación...",
              "noResult": "Sin resultados"
            }
          }
        }
      },
      "firewall": {
        "collabWarningMessage": "Su cuenta no tiene un colaborador asociado, la aplicación puede funcionar mal",
        "noGroupForUserWarningMessage": "El uso de SKINreporter requiere que su cuenta de usuario esté vinculada a un grupo de usuarios"
      },
      genericEditScreen: {
        genericErrorMsg: "MISSING TRANSLATION",
        saveErrorMsg: "MISSING TRANSLATION",
        saveSuccessMsg: "MISSING TRANSLATION",
      },
      "maskFields": {
        "boolean": {
          "no": "No",
          "undefined": "Indefinido",
          "yes": "Sí"
        },
        "entitySelect": {
          "modalPlaceholder": "Palabras clave o identificadores..."
        }
      },
      "editItemScreen": {
        "author": "Autor",
        "inventoryNumber": "Número de inventario",
        "confirmButton": "Confirmar",
        "editButton": "Modificar",
        "saveNotification": {
          "errorMessage": "Se ha producido un error al guardar el objeto",
          "successMessage": "El objeto se ha guardado correctamente"
        },
        sections: {
          creation: "Creación",
          description: "Descripción",
          identification: "Identificación",
          location: "Ubicación",
          notes: "Notas",
          state: "Estado",
        },
        "deleteNotification": {
          "errorMessage": "Se ha producido un error al borrar el objeto no sincronizado",
          "successMessage": "El objeto se ha borrado correctamente"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Se ha producido un error al borrar los cambios no sincronizado",
          "successMessage": "Los cambios han sido cancelados"
        },
        "errorMessages": {
          "inventoryNumberNotUnique": "Este número de inventario ya ha sido asignado"
        },
        fieldDisabledOffline: "Este campo no está disponible en modo sin conexión",
        "menu": {
          "saveModifications": "Guardar los cambios",
          "deleteNotSynchronizedNewItem": "Eliminar el nuevo objeto",
          "deleteModificationsNotSynchronized": "Eliminar las modificaciones no sincronizadas",
          "offlineWarning": "Los cambios están guardados en el dispositivo, tendrá que sincronizarlos con la base de datos cuando la red vuelva a estar disponible.",
          "offlineShortWarning": "Modificado en este dispositivo",
          "addToCampaign": "Recoger este artículo"
        }
      },
      "editRecordScreen": {
        "auditDate": "Fecha de reacondicionamiento",
        fieldDisabledOffline: "Este campo no está disponible en modo sin conexión",
        "foldAll": "Reducir todo",
        "itemNotice": "Ficha de objeto",
        "linkedObject": "Objeto relacionado",
        "realTimeLocation": "Localización en tiempo real",
        "recordStatus": "Estado del registro maestro",
        "unfoldAll": "Desplegar todo",
        "medias": {
          "accordionPanelTitle": "MEDIA"
        },
        "menu": {
          "saveModifications": "Guardar los cambios",
          "changeRecordStatus": "Cambiar el estado del registro",
          "statusModificationWarning": "¿Confirmar el cambio?",
          "offlineWarning": "Los cambios están guardados en el dispositivo, tendrá que sincronizarlos con la base de datos cuando la red vuelva a estar disponible.",
          "offlineShortWarning": "Modificado en este dispositivo"
        },
        "notifications": {
          "saveError": "Se ha producido un error al guardar",
          "saveSuccess": "Ficha de auditoría guardada",
          "stateTransitionError": "Se ha producido un error al cambiar el estado del registro",
          "stateTransitionSuccess": "Estado del registro modificado correctamente"
        }
      },
      "defectTree": {
        "annotation": {
          "deleteConfirmationMessage": "¿Confirmar la eliminación?",
          "defaultImageConfirmationMessage": "¿Establecer como imagen principal?"
        }
      },
      "itemSearchScreen": {
        "camera": "CÁMARA FOTOGRÁFICA",
        "modifyRecord": "MODIFICAR EL REGISTRO DEL OBJETO",
        "createNewItem": "CREAR UN NUEVO OBJETO"
      },
      "searchFeaturedCard": {
        "institutionLabel": "Institución"
      },
      selectItemErrorDialog: {
        cancel: "Cancelar el objeto",
        cancelAll: "Cancelar todos los objetos",
        description: "La selección de {0} objetos ha fallado",
        retry: "Volver a intentar para este objeto",
        retryAll: "Volver a intentar para todos los objetos",
        title: "Se ha producido un error al seleccionar las imágenes",
      },
      "auditCampaignSearchScreen": {
        "inProgress": "En proceso",
        "title": "Proyectos de control/auditoría en proceso",
        "noResultsPlaceholder": "No está autorizado para trabajar en ninguna campaña en este momento"
      },
      "recordSearchScreen": {
        "auditors": "Auditores",
        "campaignManager": "Director de campaña",
        "inventoryNumber": "Número de inventario",
        "projectCreationDate": "Fecha de creación del proyecto",
        "projectType": "Tipo de proyecto",
        "realTimeLocation": "Localización en tiempo real",
        "recordRefNumber": "Número de referencia del registro",
        "status": "Estado",
        "title": "Fichas de auditoría ",
        "unknowLocation": "Ubicación desconocida",
        "menu": {
          "addItem": "Añadir un objeto"
        }
      },
      "state": {
        "all": "Todos",
        "archived": "Archivado",
        "canceled": "Cancelado",
        "finalized": "Completado",
        "inPreparation": "En preparación",
        "inProgress": "En proceso",
        "programmed": "Planificado",
        "toValidated": "Por validar",
        "validated": "Validado",
        "aborted": "Interrumpido",
        "success": "Completado correctamente",
        "error": "Error",
        "none": "Ninguna sincronización previa"
      },
      "time": {
        "hours": "hora(s)",
        "minutes": "minuto(s)",
        "seconds": "segundo(s)"
      },
      "locationSelector": {
        "inputPlaceholder": "Introduzca una ubicación",
        "title": "Seleccione una ubicación",
        "validate": "Validar"
      },
      "synchroModal": {
        "title": "Sincronización",
        "lastFetch": "Última recuperación",
        "duration": "Duración",
        "status": "Estado",
        "details": "Detalles",
        "lastSynchro": "Última sincronización",
        "noEntityToSync": "No hay entidades que sincronizar",
        "connectionWarningPrefix": "Debe estar conectado a Internet ",
        "connectWarningSend": "enviar",
        "connectWarningRetrieve": "recuperar",
        "connectionWarningSuffix": "datos",
        "noDataToSync": "No hay datos que sincronizar por el momento",
        "localIconInfoPrefix": "El icono",
        "localIconInfoSuffix": " indica que los datos correspondientes han sido modificados localmente y tendrán que ser sincronizados con la base de datos remota.",
        "retrieveAll": "Recuperar todo",
        "finishedSynchros": "sincronizaciones completadas",
        "syncAll": "Sincronizar todo",
        "remainsToSynchronize": "Queda por sincronizar",
        "cleanImageCache": "Eliminar imágenes fantasma de la memoria caché",
        "cachedImagedCleaned": "Se han eliminado las imágenes fantasma",
        "cleanCacheDown": "Borrar la memoria caché",
        "cacheDownCleaned": "Se ha vaciado la memoria caché",
        "cleanCacheUp": "Borrar todos los cambios no sincronizados",
        "cacheUpCleaned": "Se han eliminado todos los cambios no sincronizados"
      },
      "entityNames": {
        "items": "Objetos",
        archives: "MISSING TRANSLATION",
        "auditRecords": "Fichas de auditoría ",
        "audits": "Proyectos de auditoría ",
        "thesaurusTerms": "Términos del tesauro",
        "thesaurus": "Tesauro",
        "entityFields": "Datos del sistema",
        "collaborators": "Personal",
        "authorities": "Autoridades",
        "aliases": "Alias",
        "locations": "Ubicaciones",
        "works": "Obras",
        "expressions": "Expresiones",
        "manifestations": "Manifestaciones",
        "specimens": "MISSING TRANSLATION"
      },
      "search": {
        "options": {
          "sortType": {
            "auditType": "Tipo de proyecto",
            "campaignCreationDate": "Fecha de creación de la campaña",
            "identificationNumber": "Número de identificación",
            "creationDate": "Fecha de creación",
            "identifier": "Identificador principal",
            "lastModification": "Última modificación",
            "mainTitle": "Título principal",
            "referenceNumber": "Número de referencia"
          }
        },
        "queryPlaceholder": "Palabras clave o número de campaña",
        "totalCount": "{totalResults} Resultado(s) : 1 -",
        "noResults": "Sin resultados",
        "title": "Objetos de museo"
      },
      "itemCreationImagePopup": {
        "title": "Añadir una imagen",
        "addImage": "AÑADIR UNA IMAGEN",
        "ignore": "DESPUÉS, IGNORE ESTE PASO"
      },
      uploadImageFailureDialog: {
        cancel: "Cancelar la imagen {0}",
        cancelAll: "Cancelar todas las imágenes",
        description: "La transferencia de {0} imágenes ha fallado",
        imageAndNumber: "Imagen {0}",
        retry: "Volver a intentar para la imagen {0}",
        retryAll: "Volver a intentar para todas las imágenes",
        title: "Se ha producido un error al transferir las imágenes ",
      },
      "SpecimenSearchScreen": {
        "createNewSpecimen": "MISSING TRANSLATION"
      }
    },
    "it": {
        "countryCode": "it",
        "alerts": {
          "workspace": {
            "unableToChangeWorkspace": "Impossibile cambiare lo spazio di lavoro",
            "unableToLoadWorkspace": "Caricamento dell'area di lavoro non riuscito",
          },
          "permissions": {
            "camera": {
              askForPermission: "SKR-Audit ha bisogno di un'autorizzazione per accedere alla telecamera. Questa autorizzazione è necessaria per le funzionalità di scansione dei codici a barre/QR. Senza questa autorizzazione, queste funzioni non possono essere fornite.",
              permissionDeniedWarning: "Il permesso di accedere alla telecamera è stato precedentemente negato a SKR-Audit. Le funzionalità di scansione di codici a barre/QR non sono quindi disponibili. Per potervi accedere, autorizzare manualmente l'accesso alla telecamera per SKR-Audit.",
            }
          },
          "medias": {
            "failUpload": "Non è riuscito a caricare il supporto",
            "failGetIdFromFileName": "Il supporto è stato caricato, ma Skin-Reporter non lo trova.",
          },
        },
        archiveEditScreen: {
          saveAlert: {
            errorMessage: "MISSING TRANSLATION",
            successMessage: "MISSING TRANSLATION",
          },
        },
        archiveEditScreenHeader: {
          cote: "MISSING TRANSLATION",
          descriptionLevel: "MISSING TRANSLATION",
        },
        archiveSearchScreen: {
          createNewArchive: "MISSING TRANSLATION",
        },
        "auth": {
          "login": {
            "error": {
              "credentials": "Le sue credenziali non sono corrette",
              "network": "La comunicazione con il server è fallita"
            },
            "form": {
              "password": {
                "error": "Inserisca il suo nome utente",
                "label": "Password"
              },
              "submit": "Accesso",
              "submitting": "Accesso...",
              "username": {
                "error": "Inserisca la sua password",
                "label": "Nome dell' utente"
              }
            }
          },
          "renew": {
            "slowNetwork": "Sembra che ci voglia più tempo del solito, non uscire dall'applicazione.",
            "spinner": "La riconnettiamo..."
          },
          sso: {
            errors: {
              authenticationFailed: "Errore"
            },
            selectIDP: "Autentica con...",
            otherIDPs: "Altri tipi di conti",
          },
        },
        "actionBar": {
          "newItems": "Nuovi oggetti",
          "auditCampaign": "Le campagne di censimento",
          "synchro": "Sincronizzazione"
        },
        autoCompleteTextField: {
          modal: {
            okButton: "OK",
          },
        },
        "cameraScanner": {
          "scanCode": "Scannerizzare il codice",
          "cancel": "Annullare",
          errors: {
            cameraNotFound: "Nessuna videocamera rilevata",
          },
        },
        createArchiveModal: {
          creationFailed: "MISSING TRANSLATION",
          descriptionLevel: "MISSING TRANSLATION",
          submitBtn: "MISSING TRANSLATION",
          submitting: "MISSING TRANSLATION",
          title: "MISSING TRANSLATION",
        },
        "navbar": {
          "contextMenuModal": {
            "buildDate": "Distribuire il",
            "checkForUpdate": {
              "help": "Se è disponibile un aggiornamento, questo verrà installato automaticamente.",
              "title": "Verifichi se ci sono aggiornamenti"
            },
            "clearCache": {
              "help": "Se si è offline, si elimina l'accesso a tutti i dati memorizzati sul dispositivo.",
              "title": "Svuotare la cache"
            },
            "overrideLocale": {
              "help": "Verrà utilizzata la lingua inglese e le impostazioni del dispositivo verranno ignorate.",
              "title": "Forza la lingua inglese"
            },
            "resetLocaleOverride": {
              "help": "La lingua utilizzata dipende dalle impostazioni del dispositivo.",
              "title": "Reimpostare la lingua"
            },
            "serviceWorker": {
              help: "Il banner di aggiornamento continua ad apparire? Clicca qui!",
              title: "Chiudi il banner di aggiornamento",
            },
            "title": "Rivelatore di pelle",
            "version": "versione",
          },
          "logout": "È sicuro di volersi scollegare?"
        },
        "offlineRibbon": {
          "offline": "È offline",
          "online": "É connesso a internet"
        },
        "proxy": {
          "error": {
            "default": "Si è verificato un errore sulla risorsa {uri}",
            "network": "La comunicazione con il server è fallita",
            "notFound": "La risorsa {uri} non è stata trovata",
            "tokenHasExpired": "La sua sessione è scaduta"
          }
        },
        "serviceWorker": {
          "updateAvailable": "È stato installato un aggiornamento. Cliccare qui per ricaricare la pagina o riavviare l'applicazione.",
          forceServiceWorkerUpdate: {
            modalTitle: "Risolvere il problema",
            versionCorrect: "Le informazioni qui sotto corrispondono alla versione e alla data fornite da SKINsoft dopo l'ultimo aggiornamento?",
            "yes": "Sì",
            "no": "No",
          },
        },
        "itemCard": {
          "detailsNotAvailable": "Dettagli non disponibili",
          "error": "Oggetto non visualizzabile",
          "identifier": "N° Inv. {identifier}",
          "identifierError": "Errore di identificazione",
          "location": "Posizione",
          "locationLabel": "Destinazione <strong>{titolo}</strong>",
          "unknownLocation": "Sconosciuto",
          "title": "Titolo",
          "locationSelector": {
            "title": "Scegliere una posizione",
            "validate": "Validare"
          }
        },
        "entity": {
          "addItem": {
            "error": {
              "api": "Non è stato possibile aggiungere l'oggetto",
              "network": "Comunicazione con il server fallita"
            },
            "form": {
              "id": {
                "alreadyAdded": "L'oggetto esiste già nel movimento",
                "emptyError": "Eseguire la scansione di un oggetto o inserire il numero di inventario.",
                "label": "Numero di inventario",
                "notFoundError": "L'oggetto è sconosciuto"
              },
              "location": {
                "emptyError": "Selezionare una posizione",
                "label": "Destinazione di arrivo",
                "notFoundError": "La posizione è sconosciuta"
              },
              "submit": "Aggiungi",
              "submitting": "Aggiungere un..."
            },
            "modal": {
              "title": "Aggiungere un oggetto"
            }
          },
          "closeMovement": {
            "form": {
              "location": {
                "inputPlaceholder": "Inserire una posizione...",
                "noResult": "Nessun risultato"
              }
            }
          }
        },
        "firewall": {
          "collabWarningMessage": "L'account non ha un collaboratore associato, l'applicazione potrebbe non funzionare correttamente.",
          "noGroupForUserWarningMessage": "L'utilizzo di SKINreporter richiede che il proprio account utente sia collegato a un gruppo di utenti"
        },
        genericEditScreen: {
          genericErrorMsg: "MISSING TRANSLATION",
          saveErrorMsg: "MISSING TRANSLATION",
          saveSuccessMsg: "MISSING TRANSLATION",
        },
        "maskFields": {
          "boolean": {
            "no": "No",
            "undefined": "Non definito",
            "yes": "Sì"
          },
          "entitySelect": {
            "modalPlaceholder": "Parole chiave o identificatori..."
          }
        },
        "editItemScreen": {
          "author": "Autore",
          "inventoryNumber": "Numero di inventario",
          "confirmButton": "Confermare",
          "editButton": "Modificare",
          "saveNotification": {
            "errorMessage": "Si è verificato un errore durante il salvataggio dell'oggetto",
            "successMessage": "Il backup dell'oggetto è stato eseguito con successo"
          },
          sections: {
            creation: "Creazione",
            description: "Descrizione",
            identification: "Identificazione",
            location: "Posizione",
            notes: "Note",
            state: "Stato Abbandono dell'oggetto",
          },
          "deleteNotification": {
            "errorMessage": "Si è verificato un errore durante l'eliminazione dell'oggetto non sincronizzato",
            "successMessage": "L'oggetto è stato eliminato con successo"
          },
          "deleteModificationsNotification": {
            "errorMessage": "Si è verificato un errore durante l'eliminazione delle modifiche non sincronizzate",
            "successMessage": "Le modifiche sono state annullate"
          },
          "errorMessages": {
            "inventoryNumberNotUnique": "Questo numero d'inventario è già stato assegnato"
          },
          fieldDisabledOffline: "Questo campo non è disponibile in modalità offline",
          "menu": {
            "saveModifications": "Salva le modifiche",
            "deleteNotSynchronizedNewItem": "Cancellare il nuovo oggetto",
            "deleteModificationsNotSynchronized": "Cancellare le modifiche non sincronizzate",
            "offlineWarning": "Le modifiche vengono salvate sul dispositivo",
            "offlineShortWarning": "Modificato su questo dispositivo",
            "addToCampaign": "Raccogliere questo oggetto"
          },
        },
        "editRecordScreen": {
          "auditDate": "Data di raccolta",
          fieldDisabledOffline: "Questo campo non è disponibile in modalità offline",
          "foldAll": "Ridurre tutti",
          "itemNotice": "Record dell'oggetto",
          "linkedObject": "Oggetto collegato",
          "realTimeLocation": "Posizione in tempo reale",
          "recordStatus": "Stato del record",
          "unfoldAll": "Aprire tutti",
          "medias": {
            "accordionPanelTitle": "MEDIA"
          },
          "menu": {
            "saveModifications": "Salva le modifiche",
            "changeRecordStatus": "Modificare lo stato del record",
            "statusModificationWarning": "Confermare il cambiamento?",
            "offlineWarning": "Le modifiche vengono salvate sul dispositivo",
            "offlineShortWarning": "Modificato su questo dispositivo"
          },
          "notifications": {
            "saveError": "Si è verificato un errore durante il salvataggio",
            "saveSuccess": "Scheda di riepilogo salvata",
            "stateTransitionError": "Si è verificato un errore durante la modifica dello stato del record",
            "stateTransitionSuccess": "Stato del record modificato con successo"
          }
        },
        "defectTree": {
          "annotation": {
            "deleteConfirmationMessage": "Confermare la cancellazione?",
            "defaultImageConfirmationMessage": "Impostare come immagine predefinita?"
          }
        },
        "itemSearchScreen": {
          "camera": "FOTOCAMERA",
          "modifyRecord": "MODIFICARE IL RECORD DELL'OGGETTO",
          "createNewItem": "CREARE UN NUOVO OGGETTO"
        },
        "searchFeaturedCard": {
          "institutionLabel": "Istituzione"
        },
        selectItemErrorDialog: {
          cancel: "Abbandono dell'oggetto",
          cancelAll: "Abbandono di tutti gli oggetti",
          description: "La selezione di {0} oggetti non è riuscita.",
          retry: "Riprova per questo oggetto",
          retryAll: "Riprova per tutti gli oggetti",
          title: "Impossibile selezionare le immagini",
        },
        "auditCampaignSearchScreen": {
          "inProgress": "In corso",
          "title": "Progetti di registrazione/censimento in corso",
          "noResultsPlaceholder": "Non siete autorizzati a lavorare su nessuna campagna al momento"
        },
        "recordSearchScreen": {
          "auditors": "Collezionisti",
          "campaignManager": "Responsabile della campagna",
          "inventoryNumber": "Numero di inventario",
          "projectCreationDate": "Data di creazione del progetto",
          "projectType": "Tipo di progetto",
          "realTimeLocation": "Posizione in tempo reale",
          "recordRefNumber": "Riferimento al file",
          "status": "Stato",
          "title": "Fogli di stato",
          "unknowLocation": "Posizione sconosciuta",
          "menu": {
            "addItem": "Aggiungere un oggetto"
          }
        },
        "state": {
          "all": "Tutti",
          "archived": "Archiviato",
          "canceled": "Annullato",
          "finalized": "Completato",
          "inPreparation": "In preparazione",
          "inProgress": "In corso",
          "programmed": "Pianificato",
          "toValidated": "Da convalidare",
          "validated": "Convalidato",
          "aborted": "Non più in uso",
          "success": "Completato con successo",
          "error": "Errore",
          "none": "Nessuna sincronizzazione precedente"
        },
        "time": {
          "hours": "ora/e",
          "minutes": "minuti",
          "seconds": "secondo(i)"
        },
        "locationSelector": {
          "inputPlaceholder": "Inserire una posizione",
          "title": "Scegliere una posizione",
          "validate": "Convalidare"
        },
        "synchroModal": {
          "title": "Sincronizzazione",
          "lastFetch": "Ultimo recupero",
          "duration": "Durata",
          "status": "Stato",
          "details": "Dettagli",
          "lastSynchro": "Ultima sincronizzazione",
          "noEntityToSync": "Nessuna entità da sincronizzare",
          "connectionWarningPrefix": "È necessario essere collegati a internet per poter",
          "connectWarningSend": "inviare",
          "connectWarningRetrieve": "recuperare",
          "connectionWarningSuffix": "dati",
          "noDataToSync": "Al momento non ci sono dati da sincronizzare",
          "localIconInfoPrefix": "L'icona",
          "localIconInfoSuffix": " indica che i dati corrispondenti sono stati modificati localmente e dovranno essere sincronizzati con il database remoto.",
          "retrieveAll": "Recupera tutti",
          "finishedSynchros": "sincronizzazioni completate",
          "syncAll": "Sincronizzare tutti",
          "remainsToSynchronize": "Ancora da sincronizzare",
          "cleanImageCache": "Rimozione delle immagini fantasma dalla cache",
          "cachedImagedCleaned": "Le immagini fantasma sono state rimosse!",
          "cleanCacheDown": "Pulire la cache",
          "cacheDownCleaned": "La cache è stata svuotata!",
          "cleanCacheUp": "Cancellare tutte le modifiche non sincronizzate",
          "cacheUpCleaned": "Tutte le modifiche non sincronizzate sono state eliminate!"
        },
        "entityNames": {
          "items": "Articoli",
          archives: "MISSING TRANSLATION",
          "auditRecords": "Schede di raccolta",
          "audits": "Progetti di raccolta",
          "thesaurusTerms": "Termini del thesaurus",
          "thesaurus": "Tesauro",
          "entityFields": "Dati del sistema",
          "collaborators": "Collaboratori",
          "authorities": "Autorità",
          "aliases": "Alias",
          "locations": "Luoghi",
          "works": "Opere",
          "expressions": "Espressioni",
          "manifestations": "Eventi",
          "specimens": "MISSING TRANSLATION"
        },
        "search": {
          "options": {
            "sortType": {
              "auditType": "Tipo di progetto",
              "campaignCreationDate": "Data di creazione della campagna",
              "creationDate": "Data di creazione",
              "identificationNumber": "Numero di identificazione",
              "identifier": "Identificatore principale",
              "lastModification": "Ultima modifica",
              "mainTitle": "Titolo principale",
              "referenceNumber": "Numero di riferimento"
            }
          },
          "queryPlaceholder": "Parole chiave o numero della campagna",
          "totalCount": "Risultato(i) ",
          "noResults": "Nessun risultato",
          "title": "Oggetti del museo"
        },
        "itemCreationImagePopup": {
          "title": "Aggiungere un'immagine",
          "addImage": "AGGIUNGERE UN'IMMAGINE",
          "ignore": "IN SEGUITO, SALTARE QUESTO PASSAGGIO"
        },
        uploadImageFailureDialog: {
          cancel: "Abbandona l'immagine {0}",
          cancelAll: "Abbandona tutte le immagini",
          description: "Il caricamento di {0} immagini non è riuscito.",
          imageAndNumber: "Immagine {0}",
          retry: "Riprova per l'immagine {0}",
          retryAll: "Riprova per tutte le immagini",
          title: "Caricamento immagine fallito",
        },
        "SpecimenSearchScreen": {
          "createNewSpecimen": "MISSING TRANSLATION"
        }
    },
    "no": {
        "countryCode": "no",
        "alerts": {
          "workspace": {
            "unableToChangeWorkspace": "Kunne ikke endre arbeidsområdet",
            "unableToLoadWorkspace": "Lasting av arbeidsområdet mislyktes",
          },
          "permissions": {
            "camera": {
              askForPermission: "SKR-Audit trenger tillatelse til å få tilgang til kameraet. Denne tillatelsen er nødvendig for strekkode-/QR-kodeskanningsfunksjonene. Uten denne tillatelsen kan ikke disse funksjonene leveres.",
              permissionDeniedWarning: "SKR-Audit har tidligere blitt nektet tilgang til kameraet. Funksjonene for skanning av strekkoder/QR-koder er derfor ikke tilgjengelige. For å få tilgang til disse må du manuelt autorisere tilgang til kameraet for SKR-Audit.",
            }
          },
          "medias": {
            "failUpload": "Kunne ikke laste opp mediet",
            "failGetIdFromFileName": "Mediet er lastet opp, men Skin-Reporter finner det ikke",
          },
        },
        archiveEditScreen: {
          saveAlert: {
            errorMessage: "MISSING TRANSLATION",
            successMessage: "MISSING TRANSLATION",
          },
        },
        archiveEditScreenHeader: {
          cote: "MISSING TRANSLATION",
          descriptionLevel: "MISSING TRANSLATION",
        },
        archiveSearchScreen: {
          createNewArchive: "MISSING TRANSLATION",
        },
        "auth": {
          "login": {
            "error": {
              "credentials": "Brukernavn og/eller passord er feil",
              "network": "Kommunikasjon med server mislyktes"
            },
            "form": {
              "password": {
                "error": "Vennligst skriv inn brukernavnet ditt",
                "label": "Passord"
              },
              "submit": "Logg Inn",
              "submitting": "Logger inn",
              "username": {
                "error": "Vennligst skriv inn passordet ditt",
                "label": "Brukernavn"
              }
            }
          },
          "renew": {
            "slowNetwork": "Dette tar mer tid enn vanlig. Vennligst ikke avslutt applikasjonen.",
            "spinner": "Får deg online igjen…"
          },
          sso: {
            errors: {
              authenticationFailed: "Feil: Autentiseringen feilet"
            },
            selectIDP: "Logg inn med…",
            otherIDPs: "Andre brukertyper",
          },
        },
        "actionBar": {
          "newItems": "Nye objekter",
          "auditCampaign": "Revisjonskampanjer",
          "synchro": "Synkron"
        },
        autoCompleteTextField: {
          modal: {
            okButton: "OK",
          },
        },
        "cameraScanner": {
          "scanCode": "Skann strekkoden",
          "cancel": "Annuleren",
          errors: {
            cameraNotFound: "Ingen kameraer oppdaget",
          },
        },
        createArchiveModal: {
          creationFailed: "MISSING TRANSLATION",
          descriptionLevel: "MISSING TRANSLATION",
          submitBtn: "MISSING TRANSLATION",
          submitting: "MISSING TRANSLATION",
          title: "MISSING TRANSLATION",
        },
        "navbar": {
          "contextMenuModal": {
            "buildDate": "Utplassert den",
            "checkForUpdate": {
              "help": "Hvis en oppdatering er tilgjengelig, installeres den automatisk.",
              "title": "Vennligst se etter oppdateringer"
            },
            "clearCache": {
              "help": "Hvis du er frakoblet, vil dette fjerne tilgangen til alle data som er lagret på enheten din",
              "title": "Tøm hurtigbufferminnet"
            },
            "overrideLocale": {
              "help": "Det engelske språket vil bli brukt, og din enhets innstillinger vil bli ignorert",
              "title": "Overstyr lokalspråket med engelsk"
            },
            "resetLocaleOverride": {
              "help": "Språket som brukes vil avhenge av enhetens innstillinger",
              "title": "Tilbakestill språket"
            },
            "serviceWorker": {
              help: "Vises oppdateringsbanneret kontinuerlig? Klikk her!",
              title: "Lukk oppdateringsbanneret",
            },
            "title": "Skin-REPORTER",
            "version": "versjon",
          },
          "logout": "Er du sikker på at du vil logge ut?"
        },
        "offlineRibbon": {
          "offline": "Du er nå offline",
          "online": "Du er nå online"
        },
        "proxy": {
          "error": {
            "default": "Det oppsto en feil på ressursen {uri}",
            "network": "Kommunikasjon med serveren har mislyktes",
            "notFound": "Ressursen {uri} ble ikke funnet",
            "tokenHasExpired": "Økten din har utløpt"
          }
        },
        "serviceWorker": {
          "updateAvailable": "En oppdatering er installert. Du kan enten klikke her for å oppdatere siden eller start applikasjonen på nytt.",
          forceServiceWorkerUpdate: {
            modalTitle: "Løsning på problemet",
            versionCorrect: "Stemmer informasjonen nedenfor overens med versjonen og datoen gitt av SKINsoft etter den siste oppdateringen ?",
            "yes": "Ja",
            "no": "Nei",
          },
        },
        "itemCard": {
          "detailsNotAvailable": "Detaljer ikke tilgjengelige",
          "error": "Objektet kan ikke vises",
          "identifier": "Inventarnr {identifikator}",
          "identifierError": "Identifikatorfeil",
          "location": "plassering",
          "locationLabel": "Destinasjon <strong>{title}</strong>",
          "unknownLocation": "Ukjent",
          "title": "Tittel",
          "locationSelector": {
            "title": "Velg en plassering",
            "validate": "Valider"
          }
        },
        "entity": {
          "addItem": {
            "error": {
              "api": "Objektet kunne ikke legges til",
              "network": "Kommunikasjonen med serveren har mislyktes"
            },
            "form": {
              "id": {
                "alreadyAdded": "Objektet finnes allerede i denne flytting",
                "emptyError": "Vennligst skann en strekkode for et objekt eller skriv inventarnummeret",
                "label": "Inventarnummer",
                "notFoundError": "Objektet er ukjent"
              },
              "location": {
                "emptyError": "Velg en plassering",
                "label": "Ankomststed",
                "notFoundError": "Ukjent plassering"
              },
              "submit": "Legg til",
              "submitting": "Legger til..."
            },
            "modal": {
              "title": "Legg til et objekt"
            }
          },
          "closeMovement": {
            "form": {
              "location": {
                "inputPlaceholder": "Velg en plassering...",
                "noResult": "Det er ikke noe resultat"
              }
            }
          }
        },
        "firewall": {
          "collabWarningMessage": "Kontoen din har ingen tilknyttet samarbeidspartner, det kan hende at appen ikke fungerer",
          "noGroupForUserWarningMessage": "Din brukerkonto må være tilknyttet en brukergruppe for å kunne bruke SKINreporter"
        },
        genericEditScreen: {
          genericErrorMsg: "MISSING TRANSLATION",
          saveErrorMsg: "MISSING TRANSLATION",
          saveSuccessMsg: "MISSING TRANSLATION",
        },
        "maskFields": {
          "boolean": {
            "no": "Nei",
            "undefined": "Udefinert",
            "yes": "Ja"
          },
          "entitySelect": {
            "modalPlaceholder": "Søkeord eller identifikatorer..."
          }
        },
        "editItemScreen": {
          "author": "Kunstner",
          "inventoryNumber": "Inventarnummer",
          "confirmButton": "Bekreft",
          "editButton": "Endre",
          "saveNotification": {
            "errorMessage": "Det oppsto en feil under lagring av objektet",
            "successMessage": "Objektet er lagret"
          },
          sections: {
            creation: "Opprettelse",
            description: "Beskrivelse",
            identification: "Identifikasjon",
            location: "Plassering",
            notes: "Merknader",
            state: "Status",
          },
          "deleteNotification": {
            "errorMessage": "Det oppstod en feil under sletting av det usynkroniserte objektet",
            "successMessage": "Objektet er slettet"
          },
          "deleteModificationsNotification": {
            "errorMessage": "Det oppstod en feil under sletting av usynkroniserte endringer",
            "successMessage": "Endringene er kansellert"
          },
          "errorMessages": {
            "inventoryNumberNotUnique": "Questo numero d'inventario è già stato assegnato"
          },
          fieldDisabledOffline: "Dette feltet er ikke tilgjengelig i frakoblet modus",
          "menu": {
            "saveModifications": "Lagre endringene",
            "deleteNotSynchronizedNewItem": "Slett det nye objektet",
            "deleteModificationsNotSynchronized": "Slett usynkroniserte endringer",
            "offlineWarning": "Endringer lagres på denne enheten, du må synkronisere dem med databasen når nettverket er tilbake.",
            "offlineShortWarning": "Endret på denne enheten",
            "addToCampaign": "Revider objektet"
          },
        },
        "editRecordScreen": {
          "auditDate": "Revisjonsdato",
          fieldDisabledOffline: "Dette feltet er ikke tilgjengelig i frakoblet modus",
          "foldAll": "Reduser alle",
          "itemNotice": "Skjema for objektet",
          "linkedObject": "Koblet objekt",
          "realTimeLocation": "Sanntids plassering",
          "recordStatus": "Status for skjemaet",
          "unfoldAll": "Distribuere alle",
          "medias": {
            "accordionPanelTitle": "MEDIER"
          },
          "menu": {
            "saveModifications": "Lagre endringer",
            "changeRecordStatus": "Endre skjemaets status",
            "statusModificationWarning": "Bekreft endring?",
            "offlineWarning": "Endringer lagres på denne enheten, du må synkronisere dem med databasen når nettverket er tilbake.",
            "offlineShortWarning": "Endret på denne enheten"
          },
          "notifications": {
            "saveError": "Det oppsto en feil under lagring",
            "saveSuccess": "Revisjonsskjema er lagret",
            "stateTransitionError": "Det oppsto en feil under endring av skjemaet",
            "stateTransitionSuccess": "Skjemaets status ble oppdatert"
          }
        },
        "defectTree": {
          "annotation": {
            "deleteConfirmationMessage": "Bekreft sletting ?",
            "defaultImageConfirmationMessage": "Angi som standardbilde?"
          }
        },
        "itemSearchScreen": {
          "camera": "KAMERA",
          "modifyRecord": "ENDRE OBJEKTETS SKJEMA",
          "createNewItem": "OPPRETT NYTT OBJEKT"
        },
        "searchFeaturedCard": {
          "institutionLabel": "Institusjon"
        },
        selectItemErrorDialog: {
          cancel: "Forlat objektet",
          cancelAll: "Forlat alle objekter",
          description: "Valget av {0} objekter mislyktes.",
          retry: "Prøv på nytt for dette objektet",
          retryAll: "Prøv på nytt for alle objekter",
          title: "Kunne ikke velge bilder",
        },
        "auditCampaignSearchScreen": {
          "inProgress": "Under arbeid",
          "title": "Revisjonskampanjer pågår",
          "noResultsPlaceholder": "Du er ikke autorisert til å jobbe med noen kampanje for øyeblikket"
        },
        "recordSearchScreen": {
          "auditors": "Revisorer",
          "campaignManager": "Kampanjeansvarlig",
          "inventoryNumber": "Inventarnummer",
          "projectCreationDate": "Dato for opprettelse av prosjektet",
          "projectType": "Prosjekttype",
          "realTimeLocation": "Sanntidsplassering",
          "recordRefNumber": "Skjemaets referanse",
          "status": "Status",
          "title": "Revisjonsskjemaer",
          "unknowLocation": "Ukjent plassering",
          "menu": {
            "addItem": "Legg til objekt"
          }
        },
        "state": {
          "all": "Alle",
          "archived": "Arkivert",
          "canceled": "Kansellert",
          "finalized": "Fullført",
          "inPreparation": "Under forberedelse",
          "inProgress": "pågår",
          "programmed": "Programmert",
          "toValidated": "Trenger validering",
          "validated": "Validert",
          "aborted": "Avbrutt",
          "success": "Fullført",
          "error": "Feil",
          "none": "Ingen tidligere synkronisering"
        },
        "time": {
          "hours": "time(r)",
          "minutes": "minutt(er)",
          "seconds": "sekund(er)"
        },
        "locationSelector": {
          "inputPlaceholder": "Tast inn en plassering",
          "title": "Velg en plassering",
          "validate": "Valider"
        },
        "synchroModal": {
          "title": "Synkronisering",
          "lastFetch": "Siste henting",
          "duration": "Varighet",
          "status": "Status",
          "details": "Detaljer",
          "lastSynchro": "Siste synkronisering",
          "noEntityToSync": "Ingen enhet å synkronisere",
          "connectionWarningPrefix": "Du må ha en internettforbindelse for å kunne",
          "connectWarningSend": "sende",
          "connectWarningRetrieve": "hente",
          "connectionWarningSuffix": "data",
          "noDataToSync": "Ingen data å synkronisere foreløpig",
          "localIconInfoPrefix": "Ikonet",
          "localIconInfoSuffix": " indikerer at de tilsvarende dataene har blitt endret lokalt og må synkroniseres med den eksterne databasen.",
          "retrieveAll": "Hent alle",
          "finishedSynchros": "Ferdige synkroniseringer",
          "syncAll": "Synkroniser alle",
          "remainsToSynchronize": "Gjenstår å synkronisere",
          "cleanImageCache": "Fjerne spøkelsesbilder fra hurtigbufferen",
          "cachedImagedCleaned": "Spøkelsesbildene er fjernet!",
          "cleanCacheDown": "Tøm hurtigbufferen",
          "cacheDownCleaned": "Cachen er tømt!",
          "cleanCacheUp": "Slett alle usynkroniserte endringer",
          "cacheUpCleaned": "Alle usynkroniserte endringer er slettet!"
        },
        "entityNames": {
          "items": "Gjenstander",
          archives: "MISSING TRANSLATION",
          "auditRecords": "Revisjonsskjemaer",
          "audits": "Revisjonsprosjekter",
          "thesaurusTerms": "Termer i tesaurusen",
          "thesaurus": "Tesaurus",
          "entityFields": "Systemdata",
          "collaborators": "Samarbeidspartnere",
          "authorities": "Myndigheter",
          "aliases": "Aliaser",
          "locations": "Plasseringer",
          "works": "Verk",
          "expressions": "Uttrykk",
          "manifestations": "Arrangementer",
          "specimens": "MISSING TRANSLATION"
        },
        "search": {
          "options": {
            "sortType": {
              "auditType": "Type prosjekt",
              "campaignCreationDate": "Dato for opprettelse av kampanjen",
              "creationDate": "Dato for opprettelse",
              "identificationNumber": "Identifikasjonsnummer",
              "identifier": "Hoved identifikator",
              "lastModification": "Siste endring",
              "mainTitle": "Hovedtittel",
              "referenceNumber": "Referansenummer"
            }
          },
          "queryPlaceholder": "Nøkkelord eller kampanjenummer",
          "totalCount": "Resultat(er): 1 -",
          "noResults": "Ingen resultater",
          "title": "Museumsobjekter"
        },
        "itemCreationImagePopup": {
          "title": "Legg til et bilde",
          "addImage": "LEGG TIL ET BILDE",
          "ignore": "SENERE, HOPP OVER DETTE TRINNET "
        },
        uploadImageFailureDialog: {
          cancel: "Avbryt bilde {0}",
          cancelAll: "Avbryt alle bilder",
          description: "Opplastingen av {0} bilder mislyktes.",
          imageAndNumber: "Bilde {0}",
          retry: "Prøv på nytt for bilde {0}",
          retryAll: "Prøv på nytt for alle bilder",
          title: "Opplasting av bilder mislyktes",
        },
        "SpecimenSearchScreen": {
          "createNewSpecimen": "MISSING TRANSLATION"
        }
    },
    "de": {
        "countryCode": "de",
        "alerts": {
          "workspace": {
            "unableToChangeWorkspace": "Wechsel des Arbeitsbereichs fehlgeschlagen",
            "unableToLoadWorkspace": "Das Laden des Arbeitsbereichs ist fehlgeschlagen",
          },
          "permissions": {
            "camera": {
              askForPermission: "SKR-Audit benötigt die Erlaubnis, auf die Kamera zuzugreifen. Diese Erlaubnis ist für die Barcode-/QR-Code-Scan-Funktionen erforderlich. Ohne diese Berechtigung können diese Funktionen nicht gewährleistet werden.",
              permissionDeniedWarning: "SKR-Audit wurde zuvor die Erlaubnis verweigert, auf die Kamera zuzugreifen. Die Barcode-/QR-Code-Scan-Funktionen sind daher nicht verfügbar. Um darauf zugreifen zu können, erlauben Sie bitte SKR-Audit manuell den Zugriff auf die Kamera.",
            }
          },
          "medias": {
            "failUpload": "Das Medium konnte nicht hochgeladen werden",
            "failGetIdFromFileName": "Die Medien wurden hochgeladen, aber Skin-Reporter kann sie nicht finden.",
          },
        },
        archiveEditScreen: {
          saveAlert: {
            errorMessage: "MISSING TRANSLATION",
            successMessage: "MISSING TRANSLATION",
          },
        },
        archiveEditScreenHeader: {
          cote: "MISSING TRANSLATION",
          descriptionLevel: "MISSING TRANSLATION",
        },
        archiveSearchScreen: {
          createNewArchive: "MISSING TRANSLATION",
        },
        "auth": {
          "login": {
            "error": {
              "credentials": "Benutzerkennung und/oder Passwort sind fehlerhaft.",
              "network": "Die Kommunikation mit dem Server ist fehlgeschlagen."
            },
            "form": {
              "password": {
                "error": "Geben sie bitte ihren Benutzernamen ein.",
                "label": "Passwort"
              },
              "submit": "sich einloggen",
              "submitting": "Verbindung",
              "username": {
                "error": "Geben sie bitte ihr Passwort ein.",
                "label": "Benutzername"
              }
            }
          },
          "renew": {
            "slowNetwork": "Es dauert länger als üblich, bitte schlieẞen sie die App nicht.",
            "spinner": "Wiederaufbau der Verbindung"
          },
          sso: {
            errors: {
              authenticationFailed: "Fehler: Die Authentifizierung konnte nicht abgeschlossen werden."
            },
            selectIDP: "Sich einloggen mit...",
            otherIDPs: "Andere Arten von Konten",
          },
        },
        "actionBar": {
          "newItems": "neue Objekte",
          "auditCampaign": "Bestandsprüfungen",
          "synchro": "Synchronisation "
        },
        autoCompleteTextField: {
          modal: {
            okButton: "Ok",
          },
        },
        "cameraScanner": {
          "scanCode": "Barcode scannen",
          "cancel": "Abbrechen",
          errors: {
            cameraNotFound: "Es wurde keine Kamera erkannt",
          },
        },
        createArchiveModal: {
          creationFailed: "MISSING TRANSLATION",
          descriptionLevel: "MISSING TRANSLATION",
          submitBtn: "MISSING TRANSLATION",
          submitting: "MISSING TRANSLATION",
          title: "MISSING TRANSLATION",
        },
        "navbar": {
          "contextMenuModal": {
            "buildDate": "eingesetzt am ",
            "checkForUpdate": {
              "help": "Wenn ein Update verfügbar ist, wird es automatisch installiert.",
              "title": "Überprüfen sie die Updates"
            },
            "clearCache": {
              "help": "Wenn sie offline sind, wird der Zugriff auf alle auf dem Gerät gespeicherten Daten gelöscht.",
              "title": "Den Cache leeren"
            },
            "overrideLocale": {
              "help": "Es werden die englische Sprache verwendet und die Einstellungen ihres Terminals ignoriert.",
              "title": "Englische Sprache erzwingen"
            },
            "resetLocaleOverride": {
              "help": "Die verwendete Sprache hängt von den Einstellungen ihres Terminals ab.",
              "title": "Sprache zurücksetzen"
            },
            "serviceWorker": {
              help: "Das Update-Banner wird ständig angezeigt? Klicken Sie hier!",
              title: "Schließen Sie das Update-Banner",
            },
            "title": "Skin-REPORTER",
            "version": "version",
          },
          "logout": "Wollen sie sich wirklich ausloggen ?"
        },
        "offlineRibbon": {
          "offline": "Sie sind offline",
          "online": "Sie sind online"
        },
        "proxy": {
          "error": {
            "default": "Bei der Ressource {uri} ist ein Fehler aufgetreten.",
            "network": "Die Kommunikation mit dem Server ist fehlgeschlagen.",
            "notFound": "Die Ressource {uri} wurde nicht gefunden. ",
            "tokenHasExpired": "Ihre Sitzung ist abgelaufen."
          }
        },
        "serviceWorker": {
          "updateAvailable": "Es wurde ein Update installiert. Klicken sie hier, um die Seite neu zu laden oder starten sie die App neu.",
          forceServiceWorkerUpdate: {
            modalTitle: "Lösung des Problems",
            versionCorrect: "Entsprechen die unten stehenden Informationen der von SKINsoft nach dem letzten Update übermittelten Version und dem Datum ?",
            yes: "Ja",
            no: "Nein",
          },
        },
        "itemCard": {
          "detailsNotAvailable": "Details nicht verfügbar.",
          "error": "Das Objekt kann nicht angezeigt werden.",
          "identifier": "Nr. Inv  {identifizieren}",
          "identifierError": "Identifikationsfehler",
          "location": "Lokalisierung",
          "locationLabel": "Ziel: <strong>{Titel}</strong>",
          "unknownLocation": "Unbekannt",
          "title": "Titel",
          "locationSelector": {
            "title": "Wählen sie einen Standort aus.",
            "validate": "Bestätigen"
          }
        },
        "entity": {
          "addItem": {
            "error": {
              "api": "Das Objekt konnte nicht hinzugefügt werden.",
              "network": "Die Kommunikation mit dem Server ist fehlgeschlagen."
            },
            "form": {
              "id": {
                "alreadyAdded": "Das Objekt ist bereist in der Liste zur Verlagerung",
                "emptyError": "Bitte scannen sie ein Objekt oder geben sie dessen Inventarnummer ein.",
                "label": "Inventarnummer",
                "notFoundError": "das Objekt ist unbekannt"
              },
              "location": {
                "emptyError": "Wählen sie einen Standort aus",
                "label": "Zielort",
                "notFoundError": "Standort ist unbekannt"
              },
              "submit": "Hinzufügen",
              "submitting": "Hinzufügen zu …"
            },
            "modal": {
              "title": "Ein Objekt hinzufügen"
            }
          },
          "closeMovement": {
            "form": {
              "location": {
                "inputPlaceholder": "Geben sie einen Standort ein.",
                "noResult": "Kein Ergebnis"
              }
            }
          }
        },
        "firewall": {
          "collabWarningMessage": "Ihrem Konto ist kein Mitarbeiter zugeordnet, die App funktioniert möglicherweise nicht",
          "noGroupForUserWarningMessage": "Die Nutzung von Skin-REPORTER setzt voraus, dass ihr Benutzerkonto mit einer Benutzergruppe verknüpft ist."
        },
        genericEditScreen: {
          genericErrorMsg: "MISSING TRANSLATION",
          saveErrorMsg: "MISSING TRANSLATION",
          saveSuccessMsg: "MISSING TRANSLATION",
        },
        "maskFields": {
          "boolean": {
            "no": "Nein",
            "undefined": "undefiniert",
            "yes": "Ja"
          },
          "entitySelect": {
            "modalPlaceholder": "Schlüsselwörter oder Identifikatoren"
          }
        },
        "editItemScreen": {
          "author": "Autor",
          "inventoryNumber": "Inventarnummer",
          "confirmButton": "Bestätigen",
          "editButton": "Bearbeiten",
          "saveNotification": {
            "errorMessage": "Beim Speichern des Objekts ist ein Fehler aufgetreten.",
            "successMessage": "Das Objekt wurde erfolgreich gespeichert."
          },
          sections: {
            creation: "Erstellung",
            description: "Beschreibung",
            identification: "Identifikation",
            location: "Lokalisierung",
            notes: "Anmerkungen",
            state: "Status",
          },
          "deleteNotification": {
            "errorMessage": "Beim Löschen des nicht synchronisierten Objekts ist ein Fehler aufgetreten.",
            "successMessage": "Das Objekt wurde erfolgreich gelöscht."
          },
          "deleteModificationsNotification": {
            "errorMessage": "Beim Löschen nicht synchronisierter Änderungen ist ein Fehler aufgetreten.",
            "successMessage": "Die Änderungen wurden rückgängig gemacht."
          },
          "errorMessages": {
            "inventoryNumberNotUnique": "Diese Inventarnummer ist bereits vergeben"
          },
          fieldDisabledOffline: "Die Eingabe in dieses Feld ist offline nicht möglich",
          "menu": {
            "saveModifications": "Änderungen speichern",
            "deleteNotSynchronizedNewItem": "Das neue Objekt löschen",
            "deleteModificationsNotSynchronized": "Die nicht synchronisierten Änderungen löschen",
            "offlineWarning": "Die Änderungen sind auf dem Gerät gespeichert und müssen mit der Datenbank synchronisiert werden, sobald das Netz wieder verfügbar ist.",
            "offlineShortWarning": "Auf diesem Gerät geändert",
            "addToCampaign": "Dieses Objekt überprüfen"
          },
        },
        "editRecordScreen": {
          "auditDate": "Datum der Bestandsprüfung",
          fieldDisabledOffline: "Die Eingabe in dieses Feld ist offline nicht möglich",
          "foldAll": "Alles verkleinern",
          "itemNotice": "Objektdatei",
          "linkedObject": "verknüpftes Objekt",
          "realTimeLocation": "Standort in Echtzeit",
          "recordStatus": "Status der Datei",
          "unfoldAll": "Alles einsetzen",
          "medias": {
            "accordionPanelTitle": "MEDIEN"
          },
          "menu": {
            "saveModifications": "Änderungen speichern",
            "changeRecordStatus": "Den Status der Datei ändern",
            "statusModificationWarning": "Die Änderung bestätigen ?",
            "offlineWarning": "Die Änderungen sind auf dem Gerät gespeichert und müssen mit der Datenbank synchronisiert werden, sobald das Netz wieder verfügbar ist.",
            "offlineShortWarning": "Auf diesem Gerät geändert"
          },
          "notifications": {
            "saveError": "Beim Speichern ist ein Fehler aufgetreten.",
            "saveSuccess": "Datei zur Bestandsprüfung gespeichert",
            "stateTransitionError": "Beim Ändern des Status der Datei ist ein Fehler aufgetreten.",
            "stateTransitionSuccess": "Status der Datei erfolgreich geändert"
          }
        },
        "defectTree": {
          "annotation": {
            "deleteConfirmationMessage": "Löschung bestätigen ?",
            "defaultImageConfirmationMessage": "Als Standardbild festlegen ?"
          }
        },
        "itemSearchScreen": {
          "camera": "FOTOAPPARAT",
          "modifyRecord": "OBJEKTDATEI ÄNDERN",
          "createNewItem": "EIN NEUES OBJEKT ANLEGEN"
        },
        "searchFeaturedCard": {
          "institutionLabel": "Institution"
        },
        selectItemErrorDialog: {
          cancel: "Objekt abbrechen",
          cancelAll: "Alle Objekte abbrechen",
          description: "Die Auswahl von {0} Objekten ist fehlgeschlagen.",
          retry: "Versuchen Sie es erneut für dieses Objekt",
          retryAll: "Versuchen Sie es erneut für alle Objekte",
          title: "Fehler bei der Auswahl von Bildern",
        },
        "auditCampaignSearchScreen": {
          "inProgress": "in Arbeit",
          "title": "laufende Erhebungs- und Prüfungsmaẞnahmen",
          "noResultsPlaceholder": "Sie sind zur Zeit nicht berechtigt, an einer Bestandsprüfung teilzunehemn."
        },
        "recordSearchScreen": {
          "auditors": "Prüfeur",
          "campaignManager": "Verantwortliche der Maẞnahme",
          "inventoryNumber": "Inventarnummer",
          "projectCreationDate": "Datum der Projekterstellung`",
          "projectType": "Art des Projekts",
          "realTimeLocation": "Standort in Echtzeit",
          "recordRefNumber": "Referenz Datei",
          "status": "Status ",
          "title": "Bestandsprüfungsdateien",
          "unknowLocation": "Standort unbekannt",
          "menu": {
            "addItem": "ein Objekt hinzufügen"
          }
        },
        "state": {
          "all": "alle",
          "archived": "archiviert",
          "canceled": "storniert",
          "finalized": "beendet",
          "inPreparation": "in Vorbereitung",
          "inProgress": "in Arbeit",
          "programmed": "geplant",
          "toValidated": "zu bestätigen",
          "validated": "bestätigt",
          "aborted": "unterbrochen",
          "success": "mit Erfolg beendet",
          "error": "Fehler",
          "none": "keine vorhergehende Synchronisation"
        },
        "time": {
          "hours": "Stunde(n)",
          "minutes": "Minute(n)",
          "seconds": "Sekunde(n)"
        },
        "locationSelector": {
          "inputPlaceholder": "einen Standort eingeben",
          "title": "einen Standort auswählen",
          "validate": "bestätigen"
        },
        "synchroModal": {
          "title": "Synchronisierung",
          "lastFetch": "letzte Wiederherstellung",
          "duration": "Dauer",
          "status": "Status ",
          "details": "Details",
          "lastSynchro": "letzte Synchronisation",
          "noEntityToSync": "keine zu synchronisierende Entität",
          "connectionWarningPrefix": "Sie müssen eine Internetverbindung haben, um …",
          "connectWarningSend": "versenden",
          "connectWarningRetrieve": "wiederherstellen",
          "connectionWarningSuffix": "der Daten",
          "noDataToSync": "Derzeit keine zu synchronisierenden Daten",
          "localIconInfoPrefix": "Das Icon",
          "localIconInfoSuffix": "bedeutet, dass die entsprechenden Daten lokal geändert wurden und mit der Remote-Datenbank synchronisiert werden müssen.",
          "retrieveAll": "alles wiederherstellen",
          "finishedSynchros": "Synchronisation beendet",
          "syncAll": "alles synchronisieren",
          "remainsToSynchronize": "bleibt zu synchronisieren",
          "cleanImageCache": "Geisterbilder aus dem Cache entfernen",
          "cachedImagedCleaned": "Geisterbilder wurden gelöscht!",
          "cleanCacheDown": "Den Cache leeren",
          "cacheDownCleaned": "Der Cache wurde geleert!",
          "cleanCacheUp": "Alle nicht synchronisierten Modifikationen löschen",
          "cacheUpCleaned": "Alle nicht synchronisierten Modifikationen wurden gelöscht!"
        },
        "entityNames": {
          "items": "Gegenstände",
          archives: "MISSING TRANSLATION",
          "auditRecords": "Bestandsprüfungsdateien",
          "audits": "Prüfungsmaẞnahmen",
          "thesaurusTerms": "Begriffe des Thesaurus",
          "thesaurus": "Thesaurus",
          "entityFields": "Systemdaten",
          "collaborators": "Mitarbeiter",
          "authorities": "Personen/Körperschaften",
          "aliases": "Alias",
          "locations": "Standorte",
          "works": "Werke",
          "expressions": "Expressionen",
          "manifestations": "Manifestationen",
          "specimens": "MISSING TRANSLATION"
        },
        "search": {
          "options": {
            "sortType": {
              "auditType": "Art des Projekts",
              "campaignCreationDate": "Datum der Maẞnahme",
              "creationDate": "Erstellungsdatum",
              "identificationNumber": "Identifikationsnummer",
              "identifier": "Hauptkennzeichen",
              "lastModification": "letzte Änderung",
              "mainTitle": "Haupttitel",
              "referenceNumber": "Referenznummer"
            }
          },
          "queryPlaceholder": "Schlüsselwort oder Nr. der Bestandsprüfungsmaẞnahme",
          "totalCount": "Resultat(e) : 1 -",
          "noResults": "kein Resultat",
          "title": "Museumsobjekt"
        },
        "itemCreationImagePopup": {
          "title": "ein Bild hinzufügen",
          "addImage": "BILD HINZUFÜGEN",
          "ignore": "SPÄTER DIESEN SCHRITT ÜBERSPRINGEN"
        },
        uploadImageFailureDialog: {
          cancel: "Bild {0} abbrechen",
          cancelAll: "Alle Bilder abbrechen",
          description: "Das Hochladen von {0} Bildern ist fehlgeschlagen.",
          imageAndNumber: "Bild {0}",
          retry: "Erneut versuchen für Bild {0}",
          retryAll: "Erneut versuchen für alle Bilder",
          title: "Fehler beim Hochladen von Bildern",
        },
        "SpecimenSearchScreen": {
          "createNewSpecimen": "MISSING TRANSLATION"
        }
    },
    "se": {
        "countryCode": "se",
        "alerts": {
          "workspace": {
            "unableToChangeWorkspace": "MISSING TRANSLATION",
            "unableToLoadWorkspace": "MISSING TRANSLATION",
          },
          "permissions": {
            "camera": {
              askForPermission: "MISSING TRANSLATION",
              permissionDeniedWarning: "MISSING TRANSLATION",
            }
          },
          "medias": {
            "failUpload": "Misslyckades med att ladda upp media",
            "failGetIdFromFileName": "Medierna har laddats upp, men Skin-Reporter kan inte hitta dem",
          },
        },
        archiveEditScreen: {
          saveAlert: {
            errorMessage: "MISSING TRANSLATION",
            successMessage: "MISSING TRANSLATION",
          },
        },
        archiveEditScreenHeader: {
          cote: "MISSING TRANSLATION",
          descriptionLevel: "MISSING TRANSLATION",
        },
        archiveSearchScreen: {
          createNewArchive: "MISSING TRANSLATION",
        },
        auth: {
          sso: {
            errors: {
              authenticationFailed: "Fel: Det gick inte att slutföra autentiseringen."
            },
            selectIDP: "Autentisera med...",
            otherIDPs: "Andra typer av konton",
          },
        },
        autoCompleteTextField: {
          modal: {
            okButton: "MISSING TRANSLATION",
          },
        },
        cameraScanner: {
          scanCode: "Skanna streckkoden",
          cancel: "Avbryt",
          errors: {
            cameraNotFound: "MISSING TRANSLATION",
          },
        },
        createArchiveModal: {
          creationFailed: "MISSING TRANSLATION",
          descriptionLevel: "MISSING TRANSLATION",
          submitBtn: "MISSING TRANSLATION",
          submitting: "MISSING TRANSLATION",
          title: "MISSING TRANSLATION",
        },
        "navbar": {
          "contextMenuModal": {
            "buildDate": "Distribuerad den",
            "checkForUpdate": {
              "help": "MISSING TRANSLATION",
              "title": "MISSING TRANSLATION"
            },
            "clearCache": {
              "help": "MISSING TRANSLATION",
              "title": "MISSING TRANSLATION"
            },
            "overrideLocale": {
              "help": "MISSING TRANSLATION",
              "title": "MISSING TRANSLATION"
            },
            "resetLocaleOverride": {
              "help": "MISSING TRANSLATION",
              "title": "MISSING TRANSLATION"
            },
            "serviceWorker": {
              help: "Visas uppdateringsbannern kontinuerligt? Klicka här!",
              title: "Stäng uppdateringsbannern",
            },
            "title": "Skin-REPORTER",
            "version": "version",
          },
          "logout": "MISSING TRANSLATION"
        },
        selectItemErrorDialog: {
        cancel: "MISSING TRANSLATION",
        cancelAll: "MISSING TRANSLATION",
        description: "MISSING TRANSLATION",
        retry: "MISSING TRANSLATION",
        retryAll: "MISSING TRANSLATION",
        title: "MISSING TRANSLATION",
      },
        "serviceWorker": {
          "updateAvailable": "MISSING TRANSLATION",
          forceServiceWorkerUpdate: {
            modalTitle: "MISSING TRANSLATION",
            versionCorrect: "Stämmer informationen nedan överens med versionen och datumet som tillhandahållits av SKINsoft efter den senaste uppdateringen?",
            yes: "MISSING TRANSLATION",
            no: "MISSING TRANSLATION",
          },
        },
        uploadImageFailureDialog: {
          cancel: "MISSING TRANSLATION",
          cancelAll: "MISSING TRANSLATION",
          description: "MISSING TRANSLATION",
          imageAndNumber: "MISSING TRANSLATION",
          retry: "MISSING TRANSLATION",
          retryAll: "MISSING TRANSLATION",
          title: "MISSING TRANSLATION",
        },
        "SpecimenSearchScreen": {
          "createNewSpecimen": "MISSING TRANSLATION"
        }
    },
}

export const dateTimeFormats = {
  en: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  "en-us": {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  fr: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  "fr-ca": {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  nl: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  es: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  it: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  no: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  de: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  se: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
}
